webpackJsonp([6,55],{

/***/ 1000:
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parseuri = __webpack_require__(917);
var debug = __webpack_require__(775)('socket.io-client:url');

/**
 * Module exports.
 */

module.exports = url;

/**
 * URL parser.
 *
 * @param {String} url
 * @param {Object} An object meant to mimic window.location.
 *                 Defaults to window.location.
 * @api public
 */

function url (uri, loc) {
  var obj = uri;

  // default to window.location
  loc = loc || (typeof location !== 'undefined' && location);
  if (null == uri) uri = loc.protocol + '//' + loc.host;

  // relative path support
  if ('string' === typeof uri) {
    if ('/' === uri.charAt(0)) {
      if ('/' === uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }

    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug('protocol-less url %s', uri);
      if ('undefined' !== typeof loc) {
        uri = loc.protocol + '//' + uri;
      } else {
        uri = 'https://' + uri;
      }
    }

    // parse
    debug('parse %s', uri);
    obj = parseuri(uri);
  }

  // make sure we treat `localhost:80` and `localhost` equally
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = '80';
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = '443';
    }
  }

  obj.path = obj.path || '/';

  var ipv6 = obj.host.indexOf(':') !== -1;
  var host = ipv6 ? '[' + obj.host + ']' : obj.host;

  // define unique id
  obj.id = obj.protocol + '://' + host + ':' + obj.port;
  // define href
  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));

  return obj;
}


/***/ }),

/***/ 1001:
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(1002);

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy () {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ 1002:
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ 1003:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(1004);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(84)))

/***/ }),

/***/ 1004:
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(1005);

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy () {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ 1005:
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ 1006:
/***/ (function(module, exports, __webpack_require__) {

/*global Blob,File*/

/**
 * Module requirements
 */

var isArray = __webpack_require__(918);
var isBuf = __webpack_require__(919);
var toString = Object.prototype.toString;
var withNativeBlob = typeof Blob === 'function' || (typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]');
var withNativeFile = typeof File === 'function' || (typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]');

/**
 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
 * Anything with blobs or files should be fed through removeBlobs before coming
 * here.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @api public
 */

exports.deconstructPacket = function(packet) {
  var buffers = [];
  var packetData = packet.data;
  var pack = packet;
  pack.data = _deconstructPacket(packetData, buffers);
  pack.attachments = buffers.length; // number of binary 'attachments'
  return {packet: pack, buffers: buffers};
};

function _deconstructPacket(data, buffers) {
  if (!data) return data;

  if (isBuf(data)) {
    var placeholder = { _placeholder: true, num: buffers.length };
    buffers.push(data);
    return placeholder;
  } else if (isArray(data)) {
    var newData = new Array(data.length);
    for (var i = 0; i < data.length; i++) {
      newData[i] = _deconstructPacket(data[i], buffers);
    }
    return newData;
  } else if (typeof data === 'object' && !(data instanceof Date)) {
    var newData = {};
    for (var key in data) {
      newData[key] = _deconstructPacket(data[key], buffers);
    }
    return newData;
  }
  return data;
}

/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @api public
 */

exports.reconstructPacket = function(packet, buffers) {
  packet.data = _reconstructPacket(packet.data, buffers);
  packet.attachments = undefined; // no longer useful
  return packet;
};

function _reconstructPacket(data, buffers) {
  if (!data) return data;

  if (data && data._placeholder) {
    return buffers[data.num]; // appropriate buffer (should be natural order anyway)
  } else if (isArray(data)) {
    for (var i = 0; i < data.length; i++) {
      data[i] = _reconstructPacket(data[i], buffers);
    }
  } else if (typeof data === 'object') {
    for (var key in data) {
      data[key] = _reconstructPacket(data[key], buffers);
    }
  }

  return data;
}

/**
 * Asynchronously removes Blobs or Files from data via
 * FileReader's readAsArrayBuffer method. Used before encoding
 * data as msgpack. Calls callback with the blobless data.
 *
 * @param {Object} data
 * @param {Function} callback
 * @api private
 */

exports.removeBlobs = function(data, callback) {
  function _removeBlobs(obj, curKey, containingObject) {
    if (!obj) return obj;

    // convert any blob
    if ((withNativeBlob && obj instanceof Blob) ||
        (withNativeFile && obj instanceof File)) {
      pendingBlobs++;

      // async filereader
      var fileReader = new FileReader();
      fileReader.onload = function() { // this.result == arraybuffer
        if (containingObject) {
          containingObject[curKey] = this.result;
        }
        else {
          bloblessData = this.result;
        }

        // if nothing pending its callback time
        if(! --pendingBlobs) {
          callback(bloblessData);
        }
      };

      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
    } else if (isArray(obj)) { // handle array
      for (var i = 0; i < obj.length; i++) {
        _removeBlobs(obj[i], i, obj);
      }
    } else if (typeof obj === 'object' && !isBuf(obj)) { // and object
      for (var key in obj) {
        _removeBlobs(obj[key], key, obj);
      }
    }
  }

  var pendingBlobs = 0;
  var bloblessData = data;
  _removeBlobs(bloblessData);
  if (!pendingBlobs) {
    callback(bloblessData);
  }
};


/***/ }),

/***/ 1007:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 1008:
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 1009:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 1010:
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__(1011);

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = __webpack_require__(718);


/***/ }),

/***/ 1011:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var transports = __webpack_require__(921);
var Emitter = __webpack_require__(717);
var debug = __webpack_require__(778)('engine.io-client:socket');
var index = __webpack_require__(925);
var parser = __webpack_require__(718);
var parseuri = __webpack_require__(917);
var parseqs = __webpack_require__(776);

/**
 * Module exports.
 */

module.exports = Socket;

/**
 * Socket constructor.
 *
 * @param {String|Object} uri or options
 * @param {Object} options
 * @api public
 */

function Socket (uri, opts) {
  if (!(this instanceof Socket)) return new Socket(uri, opts);

  opts = opts || {};

  if (uri && 'object' === typeof uri) {
    opts = uri;
    uri = null;
  }

  if (uri) {
    uri = parseuri(uri);
    opts.hostname = uri.host;
    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
    opts.port = uri.port;
    if (uri.query) opts.query = uri.query;
  } else if (opts.host) {
    opts.hostname = parseuri(opts.host).host;
  }

  this.secure = null != opts.secure ? opts.secure
    : (typeof location !== 'undefined' && 'https:' === location.protocol);

  if (opts.hostname && !opts.port) {
    // if no port is specified manually, use the protocol default
    opts.port = this.secure ? '443' : '80';
  }

  this.agent = opts.agent || false;
  this.hostname = opts.hostname ||
    (typeof location !== 'undefined' ? location.hostname : 'localhost');
  this.port = opts.port || (typeof location !== 'undefined' && location.port
      ? location.port
      : (this.secure ? 443 : 80));
  this.query = opts.query || {};
  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
  this.upgrade = false !== opts.upgrade;
  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
  this.forceJSONP = !!opts.forceJSONP;
  this.jsonp = false !== opts.jsonp;
  this.forceBase64 = !!opts.forceBase64;
  this.enablesXDR = !!opts.enablesXDR;
  this.withCredentials = false !== opts.withCredentials;
  this.timestampParam = opts.timestampParam || 't';
  this.timestampRequests = opts.timestampRequests;
  this.transports = opts.transports || ['polling', 'websocket'];
  this.transportOptions = opts.transportOptions || {};
  this.readyState = '';
  this.writeBuffer = [];
  this.prevBufferLen = 0;
  this.policyPort = opts.policyPort || 843;
  this.rememberUpgrade = opts.rememberUpgrade || false;
  this.binaryType = null;
  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;

  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
    this.perMessageDeflate.threshold = 1024;
  }

  // SSL options for Node.js client
  this.pfx = opts.pfx || undefined;
  this.key = opts.key || undefined;
  this.passphrase = opts.passphrase || undefined;
  this.cert = opts.cert || undefined;
  this.ca = opts.ca || undefined;
  this.ciphers = opts.ciphers || undefined;
  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
  this.forceNode = !!opts.forceNode;

  // detect ReactNative environment
  this.isReactNative = (typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative');

  // other options for Node.js or ReactNative client
  if (typeof self === 'undefined' || this.isReactNative) {
    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
      this.extraHeaders = opts.extraHeaders;
    }

    if (opts.localAddress) {
      this.localAddress = opts.localAddress;
    }
  }

  // set on handshake
  this.id = null;
  this.upgrades = null;
  this.pingInterval = null;
  this.pingTimeout = null;

  // set on heartbeat
  this.pingIntervalTimer = null;
  this.pingTimeoutTimer = null;

  this.open();
}

Socket.priorWebsocketSuccess = false;

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Protocol version.
 *
 * @api public
 */

Socket.protocol = parser.protocol; // this is an int

/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */

Socket.Socket = Socket;
Socket.Transport = __webpack_require__(876);
Socket.transports = __webpack_require__(921);
Socket.parser = __webpack_require__(718);

/**
 * Creates transport of the given type.
 *
 * @param {String} transport name
 * @return {Transport}
 * @api private
 */

Socket.prototype.createTransport = function (name) {
  debug('creating transport "%s"', name);
  var query = clone(this.query);

  // append engine.io protocol identifier
  query.EIO = parser.protocol;

  // transport name
  query.transport = name;

  // per-transport options
  var options = this.transportOptions[name] || {};

  // session id if we already have one
  if (this.id) query.sid = this.id;

  var transport = new transports[name]({
    query: query,
    socket: this,
    agent: options.agent || this.agent,
    hostname: options.hostname || this.hostname,
    port: options.port || this.port,
    secure: options.secure || this.secure,
    path: options.path || this.path,
    forceJSONP: options.forceJSONP || this.forceJSONP,
    jsonp: options.jsonp || this.jsonp,
    forceBase64: options.forceBase64 || this.forceBase64,
    enablesXDR: options.enablesXDR || this.enablesXDR,
    withCredentials: options.withCredentials || this.withCredentials,
    timestampRequests: options.timestampRequests || this.timestampRequests,
    timestampParam: options.timestampParam || this.timestampParam,
    policyPort: options.policyPort || this.policyPort,
    pfx: options.pfx || this.pfx,
    key: options.key || this.key,
    passphrase: options.passphrase || this.passphrase,
    cert: options.cert || this.cert,
    ca: options.ca || this.ca,
    ciphers: options.ciphers || this.ciphers,
    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
    extraHeaders: options.extraHeaders || this.extraHeaders,
    forceNode: options.forceNode || this.forceNode,
    localAddress: options.localAddress || this.localAddress,
    requestTimeout: options.requestTimeout || this.requestTimeout,
    protocols: options.protocols || void (0),
    isReactNative: this.isReactNative
  });

  return transport;
};

function clone (obj) {
  var o = {};
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = obj[i];
    }
  }
  return o;
}

/**
 * Initializes transport to use and starts probe.
 *
 * @api private
 */
Socket.prototype.open = function () {
  var transport;
  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
    transport = 'websocket';
  } else if (0 === this.transports.length) {
    // Emit error on next tick so it can be listened to
    var self = this;
    setTimeout(function () {
      self.emit('error', 'No transports available');
    }, 0);
    return;
  } else {
    transport = this.transports[0];
  }
  this.readyState = 'opening';

  // Retry with the next transport if the transport is disabled (jsonp: false)
  try {
    transport = this.createTransport(transport);
  } catch (e) {
    this.transports.shift();
    this.open();
    return;
  }

  transport.open();
  this.setTransport(transport);
};

/**
 * Sets the current transport. Disables the existing one (if any).
 *
 * @api private
 */

Socket.prototype.setTransport = function (transport) {
  debug('setting transport %s', transport.name);
  var self = this;

  if (this.transport) {
    debug('clearing existing transport %s', this.transport.name);
    this.transport.removeAllListeners();
  }

  // set up transport
  this.transport = transport;

  // set up transport listeners
  transport
  .on('drain', function () {
    self.onDrain();
  })
  .on('packet', function (packet) {
    self.onPacket(packet);
  })
  .on('error', function (e) {
    self.onError(e);
  })
  .on('close', function () {
    self.onClose('transport close');
  });
};

/**
 * Probes a transport.
 *
 * @param {String} transport name
 * @api private
 */

Socket.prototype.probe = function (name) {
  debug('probing transport "%s"', name);
  var transport = this.createTransport(name, { probe: 1 });
  var failed = false;
  var self = this;

  Socket.priorWebsocketSuccess = false;

  function onTransportOpen () {
    if (self.onlyBinaryUpgrades) {
      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
      failed = failed || upgradeLosesBinary;
    }
    if (failed) return;

    debug('probe transport "%s" opened', name);
    transport.send([{ type: 'ping', data: 'probe' }]);
    transport.once('packet', function (msg) {
      if (failed) return;
      if ('pong' === msg.type && 'probe' === msg.data) {
        debug('probe transport "%s" pong', name);
        self.upgrading = true;
        self.emit('upgrading', transport);
        if (!transport) return;
        Socket.priorWebsocketSuccess = 'websocket' === transport.name;

        debug('pausing current transport "%s"', self.transport.name);
        self.transport.pause(function () {
          if (failed) return;
          if ('closed' === self.readyState) return;
          debug('changing transport and sending upgrade packet');

          cleanup();

          self.setTransport(transport);
          transport.send([{ type: 'upgrade' }]);
          self.emit('upgrade', transport);
          transport = null;
          self.upgrading = false;
          self.flush();
        });
      } else {
        debug('probe transport "%s" failed', name);
        var err = new Error('probe error');
        err.transport = transport.name;
        self.emit('upgradeError', err);
      }
    });
  }

  function freezeTransport () {
    if (failed) return;

    // Any callback called by transport should be ignored since now
    failed = true;

    cleanup();

    transport.close();
    transport = null;
  }

  // Handle any error that happens while probing
  function onerror (err) {
    var error = new Error('probe error: ' + err);
    error.transport = transport.name;

    freezeTransport();

    debug('probe transport "%s" failed because of error: %s', name, err);

    self.emit('upgradeError', error);
  }

  function onTransportClose () {
    onerror('transport closed');
  }

  // When the socket is closed while we're probing
  function onclose () {
    onerror('socket closed');
  }

  // When the socket is upgraded while we're probing
  function onupgrade (to) {
    if (transport && to.name !== transport.name) {
      debug('"%s" works - aborting "%s"', to.name, transport.name);
      freezeTransport();
    }
  }

  // Remove all listeners on the transport and on self
  function cleanup () {
    transport.removeListener('open', onTransportOpen);
    transport.removeListener('error', onerror);
    transport.removeListener('close', onTransportClose);
    self.removeListener('close', onclose);
    self.removeListener('upgrading', onupgrade);
  }

  transport.once('open', onTransportOpen);
  transport.once('error', onerror);
  transport.once('close', onTransportClose);

  this.once('close', onclose);
  this.once('upgrading', onupgrade);

  transport.open();
};

/**
 * Called when connection is deemed open.
 *
 * @api public
 */

Socket.prototype.onOpen = function () {
  debug('socket open');
  this.readyState = 'open';
  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
  this.emit('open');
  this.flush();

  // we check for `readyState` in case an `open`
  // listener already closed the socket
  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
    debug('starting upgrade probes');
    for (var i = 0, l = this.upgrades.length; i < l; i++) {
      this.probe(this.upgrades[i]);
    }
  }
};

/**
 * Handles a packet.
 *
 * @api private
 */

Socket.prototype.onPacket = function (packet) {
  if ('opening' === this.readyState || 'open' === this.readyState ||
      'closing' === this.readyState) {
    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);

    this.emit('packet', packet);

    // Socket is live - any packet counts
    this.emit('heartbeat');

    switch (packet.type) {
      case 'open':
        this.onHandshake(JSON.parse(packet.data));
        break;

      case 'pong':
        this.setPing();
        this.emit('pong');
        break;

      case 'error':
        var err = new Error('server error');
        err.code = packet.data;
        this.onError(err);
        break;

      case 'message':
        this.emit('data', packet.data);
        this.emit('message', packet.data);
        break;
    }
  } else {
    debug('packet received with socket readyState "%s"', this.readyState);
  }
};

/**
 * Called upon handshake completion.
 *
 * @param {Object} handshake obj
 * @api private
 */

Socket.prototype.onHandshake = function (data) {
  this.emit('handshake', data);
  this.id = data.sid;
  this.transport.query.sid = data.sid;
  this.upgrades = this.filterUpgrades(data.upgrades);
  this.pingInterval = data.pingInterval;
  this.pingTimeout = data.pingTimeout;
  this.onOpen();
  // In case open handler closes socket
  if ('closed' === this.readyState) return;
  this.setPing();

  // Prolong liveness of socket on heartbeat
  this.removeListener('heartbeat', this.onHeartbeat);
  this.on('heartbeat', this.onHeartbeat);
};

/**
 * Resets ping timeout.
 *
 * @api private
 */

Socket.prototype.onHeartbeat = function (timeout) {
  clearTimeout(this.pingTimeoutTimer);
  var self = this;
  self.pingTimeoutTimer = setTimeout(function () {
    if ('closed' === self.readyState) return;
    self.onClose('ping timeout');
  }, timeout || (self.pingInterval + self.pingTimeout));
};

/**
 * Pings server every `this.pingInterval` and expects response
 * within `this.pingTimeout` or closes connection.
 *
 * @api private
 */

Socket.prototype.setPing = function () {
  var self = this;
  clearTimeout(self.pingIntervalTimer);
  self.pingIntervalTimer = setTimeout(function () {
    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
    self.ping();
    self.onHeartbeat(self.pingTimeout);
  }, self.pingInterval);
};

/**
* Sends a ping packet.
*
* @api private
*/

Socket.prototype.ping = function () {
  var self = this;
  this.sendPacket('ping', function () {
    self.emit('ping');
  });
};

/**
 * Called on `drain` event
 *
 * @api private
 */

Socket.prototype.onDrain = function () {
  this.writeBuffer.splice(0, this.prevBufferLen);

  // setting prevBufferLen = 0 is very important
  // for example, when upgrading, upgrade packet is sent over,
  // and a nonzero prevBufferLen could cause problems on `drain`
  this.prevBufferLen = 0;

  if (0 === this.writeBuffer.length) {
    this.emit('drain');
  } else {
    this.flush();
  }
};

/**
 * Flush write buffers.
 *
 * @api private
 */

Socket.prototype.flush = function () {
  if ('closed' !== this.readyState && this.transport.writable &&
    !this.upgrading && this.writeBuffer.length) {
    debug('flushing %d packets in socket', this.writeBuffer.length);
    this.transport.send(this.writeBuffer);
    // keep track of current length of writeBuffer
    // splice writeBuffer and callbackBuffer on `drain`
    this.prevBufferLen = this.writeBuffer.length;
    this.emit('flush');
  }
};

/**
 * Sends a message.
 *
 * @param {String} message.
 * @param {Function} callback function.
 * @param {Object} options.
 * @return {Socket} for chaining.
 * @api public
 */

Socket.prototype.write =
Socket.prototype.send = function (msg, options, fn) {
  this.sendPacket('message', msg, options, fn);
  return this;
};

/**
 * Sends a packet.
 *
 * @param {String} packet type.
 * @param {String} data.
 * @param {Object} options.
 * @param {Function} callback function.
 * @api private
 */

Socket.prototype.sendPacket = function (type, data, options, fn) {
  if ('function' === typeof data) {
    fn = data;
    data = undefined;
  }

  if ('function' === typeof options) {
    fn = options;
    options = null;
  }

  if ('closing' === this.readyState || 'closed' === this.readyState) {
    return;
  }

  options = options || {};
  options.compress = false !== options.compress;

  var packet = {
    type: type,
    data: data,
    options: options
  };
  this.emit('packetCreate', packet);
  this.writeBuffer.push(packet);
  if (fn) this.once('flush', fn);
  this.flush();
};

/**
 * Closes the connection.
 *
 * @api private
 */

Socket.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.readyState = 'closing';

    var self = this;

    if (this.writeBuffer.length) {
      this.once('drain', function () {
        if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      });
    } else if (this.upgrading) {
      waitForUpgrade();
    } else {
      close();
    }
  }

  function close () {
    self.onClose('forced close');
    debug('socket closing - telling transport to close');
    self.transport.close();
  }

  function cleanupAndClose () {
    self.removeListener('upgrade', cleanupAndClose);
    self.removeListener('upgradeError', cleanupAndClose);
    close();
  }

  function waitForUpgrade () {
    // wait for upgrade to finish since we can't send packets while pausing a transport
    self.once('upgrade', cleanupAndClose);
    self.once('upgradeError', cleanupAndClose);
  }

  return this;
};

/**
 * Called upon transport error
 *
 * @api private
 */

Socket.prototype.onError = function (err) {
  debug('socket error %j', err);
  Socket.priorWebsocketSuccess = false;
  this.emit('error', err);
  this.onClose('transport error', err);
};

/**
 * Called upon transport close.
 *
 * @api private
 */

Socket.prototype.onClose = function (reason, desc) {
  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
    debug('socket close with reason: "%s"', reason);
    var self = this;

    // clear timers
    clearTimeout(this.pingIntervalTimer);
    clearTimeout(this.pingTimeoutTimer);

    // stop event from firing again for transport
    this.transport.removeAllListeners('close');

    // ensure transport won't stay open
    this.transport.close();

    // ignore further transport communication
    this.transport.removeAllListeners();

    // set ready state
    this.readyState = 'closed';

    // clear session id
    this.id = null;

    // emit close event
    this.emit('close', reason, desc);

    // clean buffers after, so users can still
    // grab the buffers on `close` event
    self.writeBuffer = [];
    self.prevBufferLen = 0;
  }
};

/**
 * Filters upgrades, returning only those matching client transports.
 *
 * @param {Array} server upgrades
 * @api private
 *
 */

Socket.prototype.filterUpgrades = function (upgrades) {
  var filteredUpgrades = [];
  for (var i = 0, j = upgrades.length; i < j; i++) {
    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
  }
  return filteredUpgrades;
};


/***/ }),

/***/ 1012:
/***/ (function(module, exports) {


/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */

try {
  module.exports = typeof XMLHttpRequest !== 'undefined' &&
    'withCredentials' in new XMLHttpRequest();
} catch (err) {
  // if XMLHttp support is disabled in IE then it will throw
  // when trying to create
  module.exports = false;
}


/***/ }),

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

/* global attachEvent */

/**
 * Module requirements.
 */

var XMLHttpRequest = __webpack_require__(874);
var Polling = __webpack_require__(922);
var Emitter = __webpack_require__(717);
var inherit = __webpack_require__(777);
var debug = __webpack_require__(778)('engine.io-client:polling-xhr');
var globalThis = __webpack_require__(875);

/**
 * Module exports.
 */

module.exports = XHR;
module.exports.Request = Request;

/**
 * Empty function
 */

function empty () {}

/**
 * XHR Polling constructor.
 *
 * @param {Object} opts
 * @api public
 */

function XHR (opts) {
  Polling.call(this, opts);
  this.requestTimeout = opts.requestTimeout;
  this.extraHeaders = opts.extraHeaders;

  if (typeof location !== 'undefined') {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    this.xd = (typeof location !== 'undefined' && opts.hostname !== location.hostname) ||
      port !== opts.port;
    this.xs = opts.secure !== isSSL;
  }
}

/**
 * Inherits from Polling.
 */

inherit(XHR, Polling);

/**
 * XHR supports binary
 */

XHR.prototype.supportsBinary = true;

/**
 * Creates a request.
 *
 * @param {String} method
 * @api private
 */

XHR.prototype.request = function (opts) {
  opts = opts || {};
  opts.uri = this.uri();
  opts.xd = this.xd;
  opts.xs = this.xs;
  opts.agent = this.agent || false;
  opts.supportsBinary = this.supportsBinary;
  opts.enablesXDR = this.enablesXDR;
  opts.withCredentials = this.withCredentials;

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  opts.requestTimeout = this.requestTimeout;

  // other options for Node.js client
  opts.extraHeaders = this.extraHeaders;

  return new Request(opts);
};

/**
 * Sends data.
 *
 * @param {String} data to send.
 * @param {Function} called upon flush.
 * @api private
 */

XHR.prototype.doWrite = function (data, fn) {
  var isBinary = typeof data !== 'string' && data !== undefined;
  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
  var self = this;
  req.on('success', fn);
  req.on('error', function (err) {
    self.onError('xhr post error', err);
  });
  this.sendXhr = req;
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

XHR.prototype.doPoll = function () {
  debug('xhr poll');
  var req = this.request();
  var self = this;
  req.on('data', function (data) {
    self.onData(data);
  });
  req.on('error', function (err) {
    self.onError('xhr poll error', err);
  });
  this.pollXhr = req;
};

/**
 * Request constructor
 *
 * @param {Object} options
 * @api public
 */

function Request (opts) {
  this.method = opts.method || 'GET';
  this.uri = opts.uri;
  this.xd = !!opts.xd;
  this.xs = !!opts.xs;
  this.async = false !== opts.async;
  this.data = undefined !== opts.data ? opts.data : null;
  this.agent = opts.agent;
  this.isBinary = opts.isBinary;
  this.supportsBinary = opts.supportsBinary;
  this.enablesXDR = opts.enablesXDR;
  this.withCredentials = opts.withCredentials;
  this.requestTimeout = opts.requestTimeout;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;

  this.create();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Request.prototype);

/**
 * Creates the XHR object and sends the request.
 *
 * @api private
 */

Request.prototype.create = function () {
  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;

  var xhr = this.xhr = new XMLHttpRequest(opts);
  var self = this;

  try {
    debug('xhr open %s: %s', this.method, this.uri);
    xhr.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
        for (var i in this.extraHeaders) {
          if (this.extraHeaders.hasOwnProperty(i)) {
            xhr.setRequestHeader(i, this.extraHeaders[i]);
          }
        }
      }
    } catch (e) {}

    if ('POST' === this.method) {
      try {
        if (this.isBinary) {
          xhr.setRequestHeader('Content-type', 'application/octet-stream');
        } else {
          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        }
      } catch (e) {}
    }

    try {
      xhr.setRequestHeader('Accept', '*/*');
    } catch (e) {}

    // ie6 check
    if ('withCredentials' in xhr) {
      xhr.withCredentials = this.withCredentials;
    }

    if (this.requestTimeout) {
      xhr.timeout = this.requestTimeout;
    }

    if (this.hasXDR()) {
      xhr.onload = function () {
        self.onLoad();
      };
      xhr.onerror = function () {
        self.onError(xhr.responseText);
      };
    } else {
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 2) {
          try {
            var contentType = xhr.getResponseHeader('Content-Type');
            if (self.supportsBinary && contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') {
              xhr.responseType = 'arraybuffer';
            }
          } catch (e) {}
        }
        if (4 !== xhr.readyState) return;
        if (200 === xhr.status || 1223 === xhr.status) {
          self.onLoad();
        } else {
          // make sure the `error` event handler that's user-set
          // does not throw in the same tick and gets caught here
          setTimeout(function () {
            self.onError(typeof xhr.status === 'number' ? xhr.status : 0);
          }, 0);
        }
      };
    }

    debug('xhr data %s', this.data);
    xhr.send(this.data);
  } catch (e) {
    // Need to defer since .create() is called directly fhrom the constructor
    // and thus the 'error' event can only be only bound *after* this exception
    // occurs.  Therefore, also, we cannot throw here at all.
    setTimeout(function () {
      self.onError(e);
    }, 0);
    return;
  }

  if (typeof document !== 'undefined') {
    this.index = Request.requestsCount++;
    Request.requests[this.index] = this;
  }
};

/**
 * Called upon successful response.
 *
 * @api private
 */

Request.prototype.onSuccess = function () {
  this.emit('success');
  this.cleanup();
};

/**
 * Called if we have data.
 *
 * @api private
 */

Request.prototype.onData = function (data) {
  this.emit('data', data);
  this.onSuccess();
};

/**
 * Called upon error.
 *
 * @api private
 */

Request.prototype.onError = function (err) {
  this.emit('error', err);
  this.cleanup(true);
};

/**
 * Cleans up house.
 *
 * @api private
 */

Request.prototype.cleanup = function (fromError) {
  if ('undefined' === typeof this.xhr || null === this.xhr) {
    return;
  }
  // xmlhttprequest
  if (this.hasXDR()) {
    this.xhr.onload = this.xhr.onerror = empty;
  } else {
    this.xhr.onreadystatechange = empty;
  }

  if (fromError) {
    try {
      this.xhr.abort();
    } catch (e) {}
  }

  if (typeof document !== 'undefined') {
    delete Request.requests[this.index];
  }

  this.xhr = null;
};

/**
 * Called upon load.
 *
 * @api private
 */

Request.prototype.onLoad = function () {
  var data;
  try {
    var contentType;
    try {
      contentType = this.xhr.getResponseHeader('Content-Type');
    } catch (e) {}
    if (contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') {
      data = this.xhr.response || this.xhr.responseText;
    } else {
      data = this.xhr.responseText;
    }
  } catch (e) {
    this.onError(e);
  }
  if (null != data) {
    this.onData(data);
  }
};

/**
 * Check if it has XDomainRequest.
 *
 * @api private
 */

Request.prototype.hasXDR = function () {
  return typeof XDomainRequest !== 'undefined' && !this.xs && this.enablesXDR;
};

/**
 * Aborts the request.
 *
 * @api public
 */

Request.prototype.abort = function () {
  this.cleanup();
};

/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */

Request.requestsCount = 0;
Request.requests = {};

if (typeof document !== 'undefined') {
  if (typeof attachEvent === 'function') {
    attachEvent('onunload', unloadHandler);
  } else if (typeof addEventListener === 'function') {
    var terminationEvent = 'onpagehide' in globalThis ? 'pagehide' : 'unload';
    addEventListener(terminationEvent, unloadHandler, false);
  }
}

function unloadHandler () {
  for (var i in Request.requests) {
    if (Request.requests.hasOwnProperty(i)) {
      Request.requests[i].abort();
    }
  }
}


/***/ }),

/***/ 1014:
/***/ (function(module, exports) {


/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};


/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 1016:
/***/ (function(module, exports) {

/**
 * An abstraction for slicing an arraybuffer even when
 * ArrayBuffer.prototype.slice is not supported
 *
 * @api public
 */

module.exports = function(arraybuffer, start, end) {
  var bytes = arraybuffer.byteLength;
  start = start || 0;
  end = end || bytes;

  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }

  if (start < 0) { start += bytes; }
  if (end < 0) { end += bytes; }
  if (end > bytes) { end = bytes; }

  if (start >= bytes || start >= end || bytes === 0) {
    return new ArrayBuffer(0);
  }

  var abv = new Uint8Array(arraybuffer);
  var result = new Uint8Array(end - start);
  for (var i = start, ii = 0; i < end; i++, ii++) {
    result[ii] = abv[i];
  }
  return result.buffer;
};


/***/ }),

/***/ 1017:
/***/ (function(module, exports) {

module.exports = after

function after(count, callback, err_cb) {
    var bail = false
    err_cb = err_cb || noop
    proxy.count = count

    return (count === 0) ? callback() : proxy

    function proxy(err, result) {
        if (proxy.count <= 0) {
            throw new Error('after called too many times')
        }
        --proxy.count

        // after first error, rest are passed to err_cb
        if (err) {
            bail = true
            callback(err)
            // future error callbacks will go to error handler
            callback = err_cb
        } else if (proxy.count === 0 && !bail) {
            callback(null, result)
        }
    }
}

function noop() {}


/***/ }),

/***/ 1018:
/***/ (function(module, exports) {

/*! https://mths.be/utf8js v2.1.2 by @mathias */

var stringFromCharCode = String.fromCharCode;

// Taken from https://mths.be/punycode
function ucs2decode(string) {
	var output = [];
	var counter = 0;
	var length = string.length;
	var value;
	var extra;
	while (counter < length) {
		value = string.charCodeAt(counter++);
		if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
			// high surrogate, and there is a next character
			extra = string.charCodeAt(counter++);
			if ((extra & 0xFC00) == 0xDC00) { // low surrogate
				output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
			} else {
				// unmatched surrogate; only append this code unit, in case the next
				// code unit is the high surrogate of a surrogate pair
				output.push(value);
				counter--;
			}
		} else {
			output.push(value);
		}
	}
	return output;
}

// Taken from https://mths.be/punycode
function ucs2encode(array) {
	var length = array.length;
	var index = -1;
	var value;
	var output = '';
	while (++index < length) {
		value = array[index];
		if (value > 0xFFFF) {
			value -= 0x10000;
			output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
			value = 0xDC00 | value & 0x3FF;
		}
		output += stringFromCharCode(value);
	}
	return output;
}

function checkScalarValue(codePoint, strict) {
	if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
		if (strict) {
			throw Error(
				'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
				' is not a scalar value'
			);
		}
		return false;
	}
	return true;
}
/*--------------------------------------------------------------------------*/

function createByte(codePoint, shift) {
	return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
}

function encodeCodePoint(codePoint, strict) {
	if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
		return stringFromCharCode(codePoint);
	}
	var symbol = '';
	if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
		symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
	}
	else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
		if (!checkScalarValue(codePoint, strict)) {
			codePoint = 0xFFFD;
		}
		symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
		symbol += createByte(codePoint, 6);
	}
	else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
		symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
		symbol += createByte(codePoint, 12);
		symbol += createByte(codePoint, 6);
	}
	symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
	return symbol;
}

function utf8encode(string, opts) {
	opts = opts || {};
	var strict = false !== opts.strict;

	var codePoints = ucs2decode(string);
	var length = codePoints.length;
	var index = -1;
	var codePoint;
	var byteString = '';
	while (++index < length) {
		codePoint = codePoints[index];
		byteString += encodeCodePoint(codePoint, strict);
	}
	return byteString;
}

/*--------------------------------------------------------------------------*/

function readContinuationByte() {
	if (byteIndex >= byteCount) {
		throw Error('Invalid byte index');
	}

	var continuationByte = byteArray[byteIndex] & 0xFF;
	byteIndex++;

	if ((continuationByte & 0xC0) == 0x80) {
		return continuationByte & 0x3F;
	}

	// If we end up here, it’s not a continuation byte
	throw Error('Invalid continuation byte');
}

function decodeSymbol(strict) {
	var byte1;
	var byte2;
	var byte3;
	var byte4;
	var codePoint;

	if (byteIndex > byteCount) {
		throw Error('Invalid byte index');
	}

	if (byteIndex == byteCount) {
		return false;
	}

	// Read first byte
	byte1 = byteArray[byteIndex] & 0xFF;
	byteIndex++;

	// 1-byte sequence (no continuation bytes)
	if ((byte1 & 0x80) == 0) {
		return byte1;
	}

	// 2-byte sequence
	if ((byte1 & 0xE0) == 0xC0) {
		byte2 = readContinuationByte();
		codePoint = ((byte1 & 0x1F) << 6) | byte2;
		if (codePoint >= 0x80) {
			return codePoint;
		} else {
			throw Error('Invalid continuation byte');
		}
	}

	// 3-byte sequence (may include unpaired surrogates)
	if ((byte1 & 0xF0) == 0xE0) {
		byte2 = readContinuationByte();
		byte3 = readContinuationByte();
		codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
		if (codePoint >= 0x0800) {
			return checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
		} else {
			throw Error('Invalid continuation byte');
		}
	}

	// 4-byte sequence
	if ((byte1 & 0xF8) == 0xF0) {
		byte2 = readContinuationByte();
		byte3 = readContinuationByte();
		byte4 = readContinuationByte();
		codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
			(byte3 << 0x06) | byte4;
		if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
			return codePoint;
		}
	}

	throw Error('Invalid UTF-8 detected');
}

var byteArray;
var byteCount;
var byteIndex;
function utf8decode(byteString, opts) {
	opts = opts || {};
	var strict = false !== opts.strict;

	byteArray = ucs2decode(byteString);
	byteCount = byteArray.length;
	byteIndex = 0;
	var codePoints = [];
	var tmp;
	while ((tmp = decodeSymbol(strict)) !== false) {
		codePoints.push(tmp);
	}
	return ucs2encode(codePoints);
}

module.exports = {
	version: '2.1.2',
	encode: utf8encode,
	decode: utf8decode
};


/***/ }),

/***/ 1019:
/***/ (function(module, exports) {

/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
(function(chars){
  "use strict";

  exports.encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
    i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i+=3) {
      base64 += chars[bytes[i] >> 2];
      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
      base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
  };

  exports.decode =  function(base64) {
    var bufferLength = base64.length * 0.75,
    len = base64.length, i, p = 0,
    encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }

    var arraybuffer = new ArrayBuffer(bufferLength),
    bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i+=4) {
      encoded1 = chars.indexOf(base64[i]);
      encoded2 = chars.indexOf(base64[i+1]);
      encoded3 = chars.indexOf(base64[i+2]);
      encoded4 = chars.indexOf(base64[i+3]);

      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
  };
})("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");


/***/ }),

/***/ 1020:
/***/ (function(module, exports) {

/**
 * Create a blob builder even when vendor prefixes exist
 */

var BlobBuilder = typeof BlobBuilder !== 'undefined' ? BlobBuilder :
  typeof WebKitBlobBuilder !== 'undefined' ? WebKitBlobBuilder :
  typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder :
  typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : 
  false;

/**
 * Check if Blob constructor is supported
 */

var blobSupported = (function() {
  try {
    var a = new Blob(['hi']);
    return a.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */

var blobSupportsArrayBufferView = blobSupported && (function() {
  try {
    var b = new Blob([new Uint8Array([1,2])]);
    return b.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if BlobBuilder is supported
 */

var blobBuilderSupported = BlobBuilder
  && BlobBuilder.prototype.append
  && BlobBuilder.prototype.getBlob;

/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */

function mapArrayBufferViews(ary) {
  return ary.map(function(chunk) {
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;

      // if this is a subarray, make a copy so we only
      // include the subarray region from the underlying buffer
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }

      return buf;
    }

    return chunk;
  });
}

function BlobBuilderConstructor(ary, options) {
  options = options || {};

  var bb = new BlobBuilder();
  mapArrayBufferViews(ary).forEach(function(part) {
    bb.append(part);
  });

  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
};

function BlobConstructor(ary, options) {
  return new Blob(mapArrayBufferViews(ary), options || {});
};

if (typeof Blob !== 'undefined') {
  BlobBuilderConstructor.prototype = Blob.prototype;
  BlobConstructor.prototype = Blob.prototype;
}

module.exports = (function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return undefined;
  }
})();


/***/ }),

/***/ 1021:
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(1022);

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy () {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ 1022:
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ 1023:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module requirements.
 */

var Polling = __webpack_require__(922);
var inherit = __webpack_require__(777);
var globalThis = __webpack_require__(875);

/**
 * Module exports.
 */

module.exports = JSONPPolling;

/**
 * Cached regular expressions.
 */

var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;

/**
 * Global JSONP callbacks.
 */

var callbacks;

/**
 * Noop.
 */

function empty () { }

/**
 * JSONP Polling constructor.
 *
 * @param {Object} opts.
 * @api public
 */

function JSONPPolling (opts) {
  Polling.call(this, opts);

  this.query = this.query || {};

  // define global callbacks array if not present
  // we do this here (lazily) to avoid unneeded global pollution
  if (!callbacks) {
    // we need to consider multiple engines in the same page
    callbacks = globalThis.___eio = (globalThis.___eio || []);
  }

  // callback identifier
  this.index = callbacks.length;

  // add callback to jsonp global
  var self = this;
  callbacks.push(function (msg) {
    self.onData(msg);
  });

  // append to query string
  this.query.j = this.index;

  // prevent spurious errors from being emitted when the window is unloaded
  if (typeof addEventListener === 'function') {
    addEventListener('beforeunload', function () {
      if (self.script) self.script.onerror = empty;
    }, false);
  }
}

/**
 * Inherits from Polling.
 */

inherit(JSONPPolling, Polling);

/*
 * JSONP only supports binary as base64 encoded strings
 */

JSONPPolling.prototype.supportsBinary = false;

/**
 * Closes the socket.
 *
 * @api private
 */

JSONPPolling.prototype.doClose = function () {
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  if (this.form) {
    this.form.parentNode.removeChild(this.form);
    this.form = null;
    this.iframe = null;
  }

  Polling.prototype.doClose.call(this);
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

JSONPPolling.prototype.doPoll = function () {
  var self = this;
  var script = document.createElement('script');

  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  script.async = true;
  script.src = this.uri();
  script.onerror = function (e) {
    self.onError('jsonp poll error', e);
  };

  var insertAt = document.getElementsByTagName('script')[0];
  if (insertAt) {
    insertAt.parentNode.insertBefore(script, insertAt);
  } else {
    (document.head || document.body).appendChild(script);
  }
  this.script = script;

  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);

  if (isUAgecko) {
    setTimeout(function () {
      var iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      document.body.removeChild(iframe);
    }, 100);
  }
};

/**
 * Writes with a hidden iframe.
 *
 * @param {String} data to send
 * @param {Function} called upon flush.
 * @api private
 */

JSONPPolling.prototype.doWrite = function (data, fn) {
  var self = this;

  if (!this.form) {
    var form = document.createElement('form');
    var area = document.createElement('textarea');
    var id = this.iframeId = 'eio_iframe_' + this.index;
    var iframe;

    form.className = 'socketio';
    form.style.position = 'absolute';
    form.style.top = '-1000px';
    form.style.left = '-1000px';
    form.target = id;
    form.method = 'POST';
    form.setAttribute('accept-charset', 'utf-8');
    area.name = 'd';
    form.appendChild(area);
    document.body.appendChild(form);

    this.form = form;
    this.area = area;
  }

  this.form.action = this.uri();

  function complete () {
    initIframe();
    fn();
  }

  function initIframe () {
    if (self.iframe) {
      try {
        self.form.removeChild(self.iframe);
      } catch (e) {
        self.onError('jsonp polling iframe removal error', e);
      }
    }

    try {
      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
      iframe = document.createElement(html);
    } catch (e) {
      iframe = document.createElement('iframe');
      iframe.name = self.iframeId;
      iframe.src = 'javascript:0';
    }

    iframe.id = self.iframeId;

    self.form.appendChild(iframe);
    self.iframe = iframe;
  }

  initIframe();

  // escape \n to prevent it from being converted into \r\n by some UAs
  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
  data = data.replace(rEscapedNewline, '\\\n');
  this.area.value = data.replace(rNewline, '\\n');

  try {
    this.form.submit();
  } catch (e) {}

  if (this.iframe.attachEvent) {
    this.iframe.onreadystatechange = function () {
      if (self.iframe.readyState === 'complete') {
        complete();
      }
    };
  } else {
    this.iframe.onload = complete;
  }
};


/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/**
 * Module dependencies.
 */

var Transport = __webpack_require__(876);
var parser = __webpack_require__(718);
var parseqs = __webpack_require__(776);
var inherit = __webpack_require__(777);
var yeast = __webpack_require__(924);
var debug = __webpack_require__(778)('engine.io-client:websocket');

var BrowserWebSocket, NodeWebSocket;

if (typeof WebSocket !== 'undefined') {
  BrowserWebSocket = WebSocket;
} else if (typeof self !== 'undefined') {
  BrowserWebSocket = self.WebSocket || self.MozWebSocket;
}

if (typeof window === 'undefined') {
  try {
    NodeWebSocket = __webpack_require__(1025);
  } catch (e) { }
}

/**
 * Get either the `WebSocket` or `MozWebSocket` globals
 * in the browser or try to resolve WebSocket-compatible
 * interface exposed by `ws` for Node-like environment.
 */

var WebSocketImpl = BrowserWebSocket || NodeWebSocket;

/**
 * Module exports.
 */

module.exports = WS;

/**
 * WebSocket transport constructor.
 *
 * @api {Object} connection options
 * @api public
 */

function WS (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (forceBase64) {
    this.supportsBinary = false;
  }
  this.perMessageDeflate = opts.perMessageDeflate;
  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
  this.protocols = opts.protocols;
  if (!this.usingBrowserWebSocket) {
    WebSocketImpl = NodeWebSocket;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(WS, Transport);

/**
 * Transport name.
 *
 * @api public
 */

WS.prototype.name = 'websocket';

/*
 * WebSockets support binary
 */

WS.prototype.supportsBinary = true;

/**
 * Opens socket.
 *
 * @api private
 */

WS.prototype.doOpen = function () {
  if (!this.check()) {
    // let probe timeout
    return;
  }

  var uri = this.uri();
  var protocols = this.protocols;

  var opts = {};

  if (!this.isReactNative) {
    opts.agent = this.agent;
    opts.perMessageDeflate = this.perMessageDeflate;

    // SSL options for Node.js client
    opts.pfx = this.pfx;
    opts.key = this.key;
    opts.passphrase = this.passphrase;
    opts.cert = this.cert;
    opts.ca = this.ca;
    opts.ciphers = this.ciphers;
    opts.rejectUnauthorized = this.rejectUnauthorized;
  }

  if (this.extraHeaders) {
    opts.headers = this.extraHeaders;
  }
  if (this.localAddress) {
    opts.localAddress = this.localAddress;
  }

  try {
    this.ws =
      this.usingBrowserWebSocket && !this.isReactNative
        ? protocols
          ? new WebSocketImpl(uri, protocols)
          : new WebSocketImpl(uri)
        : new WebSocketImpl(uri, protocols, opts);
  } catch (err) {
    return this.emit('error', err);
  }

  if (this.ws.binaryType === undefined) {
    this.supportsBinary = false;
  }

  if (this.ws.supports && this.ws.supports.binary) {
    this.supportsBinary = true;
    this.ws.binaryType = 'nodebuffer';
  } else {
    this.ws.binaryType = 'arraybuffer';
  }

  this.addEventListeners();
};

/**
 * Adds event listeners to the socket
 *
 * @api private
 */

WS.prototype.addEventListeners = function () {
  var self = this;

  this.ws.onopen = function () {
    self.onOpen();
  };
  this.ws.onclose = function () {
    self.onClose();
  };
  this.ws.onmessage = function (ev) {
    self.onData(ev.data);
  };
  this.ws.onerror = function (e) {
    self.onError('websocket error', e);
  };
};

/**
 * Writes data to socket.
 *
 * @param {Array} array of packets.
 * @api private
 */

WS.prototype.write = function (packets) {
  var self = this;
  this.writable = false;

  // encodePacket efficient as it uses WS framing
  // no need for encodePayload
  var total = packets.length;
  for (var i = 0, l = total; i < l; i++) {
    (function (packet) {
      parser.encodePacket(packet, self.supportsBinary, function (data) {
        if (!self.usingBrowserWebSocket) {
          // always create a new object (GH-437)
          var opts = {};
          if (packet.options) {
            opts.compress = packet.options.compress;
          }

          if (self.perMessageDeflate) {
            var len = 'string' === typeof data ? Buffer.byteLength(data) : data.length;
            if (len < self.perMessageDeflate.threshold) {
              opts.compress = false;
            }
          }
        }

        // Sometimes the websocket has already been closed but the browser didn't
        // have a chance of informing us about it yet, in that case send will
        // throw an error
        try {
          if (self.usingBrowserWebSocket) {
            // TypeError is thrown when passing the second argument on Safari
            self.ws.send(data);
          } else {
            self.ws.send(data, opts);
          }
        } catch (e) {
          debug('websocket closed before onclose event');
        }

        --total || done();
      });
    })(packets[i]);
  }

  function done () {
    self.emit('flush');

    // fake drain
    // defer to next tick to allow Socket to clear writeBuffer
    setTimeout(function () {
      self.writable = true;
      self.emit('drain');
    }, 0);
  }
};

/**
 * Called upon close
 *
 * @api private
 */

WS.prototype.onClose = function () {
  Transport.prototype.onClose.call(this);
};

/**
 * Closes socket.
 *
 * @api private
 */

WS.prototype.doClose = function () {
  if (typeof this.ws !== 'undefined') {
    this.ws.close();
  }
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

WS.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'wss' : 'ws';
  var port = '';

  // avoid port if default for schema
  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
    ('ws' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // append timestamp to URI
  if (this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  // communicate binary support capabilities
  if (!this.supportsBinary) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

/**
 * Feature detection for WebSocket.
 *
 * @return {Boolean} whether this transport is available.
 * @api public
 */

WS.prototype.check = function () {
  return !!WebSocketImpl && !('__initialize' in WebSocketImpl && this.name === WS.prototype.name);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(873).Buffer))

/***/ }),

/***/ 1025:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1026:
/***/ (function(module, exports) {

module.exports = toArray

function toArray(list, index) {
    var array = []

    index = index || 0

    for (var i = index || 0; i < list.length; i++) {
        array[i - index] = list[i]
    }

    return array
}


/***/ }),

/***/ 1027:
/***/ (function(module, exports) {


/**
 * Expose `Backoff`.
 */

module.exports = Backoff;

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */

function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 10000;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}

/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */

Backoff.prototype.duration = function(){
  var ms = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand =  Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
  }
  return Math.min(ms, this.max) | 0;
};

/**
 * Reset the number of attempts.
 *
 * @api public
 */

Backoff.prototype.reset = function(){
  this.attempts = 0;
};

/**
 * Set the minimum duration
 *
 * @api public
 */

Backoff.prototype.setMin = function(min){
  this.ms = min;
};

/**
 * Set the maximum duration
 *
 * @api public
 */

Backoff.prototype.setMax = function(max){
  this.max = max;
};

/**
 * Set the jitter
 *
 * @api public
 */

Backoff.prototype.setJitter = function(jitter){
  this.jitter = jitter;
};



/***/ }),

/***/ 1204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_template_teacher__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_StudentVideoChat__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ChatBox__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_socket_io_client__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_socket_io_client__);






var _components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var PeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
var SessionDescription = window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitSessionDescription;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      classroomKey: null,
      currentRoom: null,
      stream: null,
      socket: null,
      socketKeepAlive: null,
      connectionTimeout: null,
      show: false,
      creating: false,
      students: [],
      chat: [],
      messageText: ''
    };
  },

  computed: {
    teacher: function teacher() {
      return this.$store.getters['teacher/get'];
    },
    classrooms: function classrooms() {
      return this.$store.getters['teacher/classrooms'];
    }
  },
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6__components_StudentVideoChat__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__components_StudentVideoChat__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7__components_ChatBox__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__components_ChatBox__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'teacherTemplate', __WEBPACK_IMPORTED_MODULE_5__components_template_teacher__["a" /* default */]), _components),
  methods: {
    getStream: function getStream(classroom_id, reconnect, classroom_key) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.show = true;
                _this.creating = true;

                _context.next = 5;
                return navigator.mediaDevices.getUserMedia({
                  video: {
                    width: {
                      min: 320,
                      ideal: 1280,
                      max: 1920
                    },
                    height: {
                      min: 240,
                      ideal: 720,
                      max: 1080
                    },
                    frameRate: 30, // Shorthand for ideal.
                    facingMode: 'environment'
                  },
                  audio: {
                    mandatory: {
                      googEchoCancellation: "false",
                      googAutoGainControl: "false",
                      googNoiseSuppression: "false",
                      googHighpassFilter: "false"
                    },
                    optional: []
                  }
                });

              case 5:
                _this.stream = _context.sent;

                if (!(!_this.stream || _this.stream && !_this.stream.active)) {
                  _context.next = 8;
                  break;
                }

                throw { message: 'Failed to get video' };

              case 8:

                _this.$refs['teacher_video'].srcObject = _this.stream;

                _this.currentRoom = classroom_id;

                if (reconnect) _this.classroomKey = classroom_key;

                _context.next = 13;
                return _this.createConnection(reconnect);

              case 13:
                _context.next = 20;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](0);

                _this.creating = false;
                alert(_context.t0.message || 'Failed to Create Room');
                _this.closeClassroom();

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 15]]);
      }))();
    },
    createConnection: function createConnection(reconnect) {
      var _this2 = this;

      // this.socket = io(`http://${location.hostname}:8082`, {
      this.socket = __WEBPACK_IMPORTED_MODULE_8_socket_io_client___default()('https://live.mindsidiomas.com.br:2020', {
        path: '/socket/classroom',
        transports: ['websocket'],
        secure: true,
        rejectUnauthorized: false
      });

      this.connectionTimeout = setTimeout(function () {
        _this2.creating = false;
        alert('Failed to connect to server');
        _this2.closeClassroom();
      }, 1000 * 5);

      this.socket.on('connect', function () {
        if (_this2.connectionTimeout) {
          clearTimeout(_this2.connectionTimeout);
          _this2.connectionTimeout = null;
        }

        if (_this2.socketKeepAlive) clearInterval(_this2.socketKeepAlive);

        _this2.socketKeepAlive = setInterval(function () {
          _this2.socket.emit('keep_alive');
        }, 5000);

        if (!reconnect) {
          _this2.socket.emit('open_classroom', { school: _this2.teacher.school, classroom_id: _this2.currentRoom });

          _this2.socket.on('classroom_opened', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return _this2.$store.dispatch('teacher/useClassroom', _this2.currentRoom);

                  case 3:
                    _this2.classroomKey = _context2.sent;
                    _context2.next = 10;
                    break;

                  case 6:
                    _context2.prev = 6;
                    _context2.t0 = _context2['catch'](0);

                    alert(_context2.t0.message || 'Failed to Create Room');
                    _this2.closeClassroom();

                  case 10:
                    _context2.prev = 10;

                    _this2.creating = false;
                    return _context2.finish(10);

                  case 13:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this2, [[0, 6, 10, 13]]);
          })));

          _this2.socket.on('classroom_failed', function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(error) {
              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _this2.creating = false;
                      alert(error.message || 'Failed to Create Room');
                      _this2.closeClassroom();

                    case 3:
                    case 'end':
                      return _context3.stop();
                  }
                }
              }, _callee3, _this2);
            }));

            return function (_x) {
              return _ref2.apply(this, arguments);
            };
          }());
        } else {
          _this2.socket.emit('reconnect_classroom', { school: _this2.teacher.school, classroom_id: _this2.currentRoom, teacher_id: _this2.teacher._id });

          _this2.socket.on('classroom_reconnected', function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(_ref4) {
              var students = _ref4.students,
                  chat = _ref4.chat;

              var _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, student;

              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.prev = 0;

                      _this2.chat = chat || [];

                      _loop = function _loop(student) {
                        student.connection = _this2.createStudentConnection(student._id);

                        _this2.students.push(student);

                        _this2.$nextTick(function () {
                          _this2.makeOffer(student);
                        });
                      };

                      _iteratorNormalCompletion = true;
                      _didIteratorError = false;
                      _iteratorError = undefined;
                      _context4.prev = 6;
                      for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(students); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        student = _step.value;

                        _loop(student);
                      }
                      _context4.next = 14;
                      break;

                    case 10:
                      _context4.prev = 10;
                      _context4.t0 = _context4['catch'](6);
                      _didIteratorError = true;
                      _iteratorError = _context4.t0;

                    case 14:
                      _context4.prev = 14;
                      _context4.prev = 15;

                      if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                      }

                    case 17:
                      _context4.prev = 17;

                      if (!_didIteratorError) {
                        _context4.next = 20;
                        break;
                      }

                      throw _iteratorError;

                    case 20:
                      return _context4.finish(17);

                    case 21:
                      return _context4.finish(14);

                    case 22:
                      _context4.next = 28;
                      break;

                    case 24:
                      _context4.prev = 24;
                      _context4.t1 = _context4['catch'](0);

                      alert(_context4.t1.message || 'Failed to Create Room');
                      _this2.closeClassroom();

                    case 28:
                      _context4.prev = 28;

                      _this2.creating = false;
                      return _context4.finish(28);

                    case 31:
                    case 'end':
                      return _context4.stop();
                  }
                }
              }, _callee4, _this2, [[0, 24, 28, 31], [6, 10, 14, 22], [15,, 17, 21]]);
            }));

            return function (_x2) {
              return _ref3.apply(this, arguments);
            };
          }());

          _this2.socket.on('reconnect_failed', function () {
            var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(error) {
              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _this2.creating = false;
                      alert(error.message || 'Failed to reconnect');
                      _this2.closeClassroom();

                    case 3:
                    case 'end':
                      return _context5.stop();
                  }
                }
              }, _callee5, _this2);
            }));

            return function (_x3) {
              return _ref5.apply(this, arguments);
            };
          }());
        }

        _this2.socket.on('connect_to_student', function (student) {
          var index = _this2.students.findIndex(function (s) {
            return s._id == student._id;
          });

          if (index > -1) {
            var current = _this2.students[index];

            if (current.connection && current.connection.connectionState != 'closed') current.connection.close();

            student.connection = _this2.createStudentConnection(student._id);

            _this2.$set(_this2.students, index, student);

            _this2.$nextTick(function () {
              _this2.makeOffer(student);
            });
          } else {
            student.connection = _this2.createStudentConnection(student._id);

            _this2.students.push(student);

            _this2.$nextTick(function () {
              _this2.makeOffer(student);
            });
          }

          var studentsList = _this2.students.filter(function (s) {
            return s._id != student._id && s.active;
          }).map(function (s) {
            return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(s));
          }).map(function (s) {
            _this2.$delete(s, 'connection');

            return s;
          });

          _this2.socket.emit('student_joined', {
            students: studentsList,
            student_obj: student
          });
        });

        _this2.socket.on('answer_made_by_student', function () {
          var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(_ref7) {
            var student_id = _ref7.student_id,
                answer = _ref7.answer;
            var student;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.prev = 0;
                    student = _this2.students.find(function (s) {
                      return s._id == student_id;
                    });

                    if (!student) {
                      _context6.next = 6;
                      break;
                    }

                    _context6.next = 5;
                    return student.connection.setRemoteDescription(new SessionDescription(answer));

                  case 5:
                    _this2.socket.emit('request_offer_by_teacher', student.socket);

                  case 6:
                    _context6.next = 12;
                    break;

                  case 8:
                    _context6.prev = 8;
                    _context6.t0 = _context6['catch'](0);

                    alert(_context6.t0.message || 'Failed to make connection with the Student');
                    console.warn(_context6.t0);

                  case 12:
                  case 'end':
                    return _context6.stop();
                }
              }
            }, _callee6, _this2, [[0, 8]]);
          }));

          return function (_x4) {
            return _ref6.apply(this, arguments);
          };
        }());

        _this2.socket.on('offer_made_by_student', function () {
          var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7(_ref9) {
            var socket = _ref9.socket,
                offer = _ref9.offer,
                student_id = _ref9.student_id;
            var student, answer;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.prev = 0;
                    student = _this2.students.find(function (s) {
                      return s._id == student_id;
                    });

                    if (!student) {
                      _context7.next = 11;
                      break;
                    }

                    _context7.next = 5;
                    return student.connection.setRemoteDescription(new SessionDescription(offer));

                  case 5:
                    _context7.next = 7;
                    return student.connection.createAnswer();

                  case 7:
                    answer = _context7.sent;
                    _context7.next = 10;
                    return student.connection.setLocalDescription(new SessionDescription(answer));

                  case 10:

                    _this2.socket.emit('make_answer_by_teacher', {
                      answer: answer,
                      to: socket
                    });

                  case 11:
                    _context7.next = 17;
                    break;

                  case 13:
                    _context7.prev = 13;
                    _context7.t0 = _context7['catch'](0);

                    console.log(_context7.t0);
                    alert('Failed to Connect with Student!');

                  case 17:
                  case 'end':
                    return _context7.stop();
                }
              }
            }, _callee7, _this2, [[0, 13]]);
          }));

          return function (_x5) {
            return _ref8.apply(this, arguments);
          };
        }());

        _this2.socket.on('message_sent', function (message) {
          _this2.chat.push(message);
        });

        _this2.socket.on('notification_sent', function (notification) {
          _this2.chat.push(notification);

          if (notification.notification_type == 'attention') {
            if (!_this2.$refs['alert-beep'].paused) _this2.$refs['alert-beep'].pause();

            _this2.$refs['alert-beep'].currentTime = 0;

            _this2.$refs['alert-beep'].play();
          }
        });

        _this2.socket.on('failed_to_send_message', function (errorMessage) {
          alert(errorMessage);
        });

        _this2.socket.on('hand_raised', function (student_id) {
          var index = _this2.students.findIndex(function (s) {
            return s._id == student_id;
          });
          _this2.$set(_this2.students[index], 'hand_raised', true);
        });

        _this2.socket.on('student_disconnected', function (student_id) {
          var index = _this2.students.findIndex(function (s) {
            return s._id == student_id;
          });

          if (index > -1) {
            var student = _this2.students[index];

            if (student.connection && student.connection.connectionState != 'closed') student.connection.close();

            _this2.$set(_this2.students[index], 'active', false);

            var studentsList = _this2.students.filter(function (s) {
              return s._id != student._id && s.active;
            }).map(function (s) {
              return s.socket;
            });

            _this2.socket.emit('student_left', {
              students: studentsList,
              student: {
                _id: student._id,
                name: student.name
              }
            });
          }
        });
      });
    },
    createStudentConnection: function createStudentConnection(student_id) {
      var _this3 = this;

      var pc = new PeerConnection({ iceServers: [{ urls: 'stun:stun.l.google.com:19302' }] });

      this.stream.getTracks().forEach(function (track) {
        return pc.addTrack(track, _this3.stream);
      });

      pc.ontrack = function () {
        var _ref10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8(event) {
          var video;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  video = _this3.$refs['student_video_' + student_id][0];


                  if (video) video.setStream(event.streams[0]);

                case 2:
                case 'end':
                  return _context8.stop();
              }
            }
          }, _callee8, _this3);
        }));

        return function (_x6) {
          return _ref10.apply(this, arguments);
        };
      }();

      return pc;
    },
    makeOffer: function makeOffer(student) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var offer;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return student.connection.createOffer();

              case 3:
                offer = _context9.sent;
                _context9.next = 6;
                return student.connection.setLocalDescription(new SessionDescription(offer));

              case 6:

                _this4.socket.emit('make_offer_by_teacher', {
                  offer: offer,
                  to: student.socket
                });
                _context9.next = 13;
                break;

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9['catch'](0);

                console.log(_context9.t0);
                alert('Failed to Connect with ' + student.name + '!');

              case 13:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this4, [[0, 9]]);
      }))();
    },
    closeClassroom: function closeClassroom() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var tracks, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, track, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, student;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;

                _this5.show = false;
                _this5.socket.emit('close_classroom');

                if (!_this5.stream) {
                  _context10.next = 24;
                  break;
                }

                tracks = _this5.stream.getTracks();
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context10.prev = 8;


                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(tracks); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  track = _step2.value;

                  track.stop();
                }
                _context10.next = 16;
                break;

              case 12:
                _context10.prev = 12;
                _context10.t0 = _context10['catch'](8);
                _didIteratorError2 = true;
                _iteratorError2 = _context10.t0;

              case 16:
                _context10.prev = 16;
                _context10.prev = 17;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 19:
                _context10.prev = 19;

                if (!_didIteratorError2) {
                  _context10.next = 22;
                  break;
                }

                throw _iteratorError2;

              case 22:
                return _context10.finish(19);

              case 23:
                return _context10.finish(16);

              case 24:

                if (_this5.currentRoom) _this5.currentRoom = null;

                if (_this5.classroomKey) _this5.classroomKey = null;

                if (_this5.socket) {
                  _this5.socket.disconnect(true);
                  _this5.socket = null;
                }

                if (_this5.socketKeepAlive) {
                  clearInterval(_this5.socketKeepAlive);
                  _this5.socketKeepAlive = null;
                }

                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context10.prev = 31;
                for (_iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this5.students); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  student = _step3.value;

                  if (student.connection && student.connection.connectionState != 'closed') student.connection.close();
                }

                _context10.next = 39;
                break;

              case 35:
                _context10.prev = 35;
                _context10.t1 = _context10['catch'](31);
                _didIteratorError3 = true;
                _iteratorError3 = _context10.t1;

              case 39:
                _context10.prev = 39;
                _context10.prev = 40;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 42:
                _context10.prev = 42;

                if (!_didIteratorError3) {
                  _context10.next = 45;
                  break;
                }

                throw _iteratorError3;

              case 45:
                return _context10.finish(42);

              case 46:
                return _context10.finish(39);

              case 47:
                _this5.students = [];
                _this5.chat = [];
                _context10.next = 54;
                break;

              case 51:
                _context10.prev = 51;
                _context10.t2 = _context10['catch'](0);

                alert(_context10.t2.message || 'Failed to close classroom');

              case 54:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this5, [[0, 51], [8, 12, 16, 24], [17,, 19, 23], [31, 35, 39, 47], [40,, 42, 46]]);
      }))();
    },
    sendMessage: function sendMessage(message) {
      if (message && this.socket && this.socket.connected) {
        this.socket.emit('send_message', {
          classroom: this.currentRoom,
          _id: this.teacher._id,
          name: 'TEACHER ' + this.teacher.name.split(' ').shift(),
          message: message,
          is_media: false
        });
        this.messageText = '';

        return true;
      }
      return false;
    },
    setMuted: function setMuted(_ref11) {
      var student_id = _ref11.student_id,
          muted = _ref11.muted;

      if (this.socket && this.socket.connected) {
        var index = this.students.findIndex(function (s) {
          return s._id == student_id;
        });

        if (!muted && this.students[index].hand_raised) this.$set(this.students[index], 'hand_raised', false);

        if (this.students[index].has_media) {
          this.$set(this.students[index], 'muted', muted);

          this.socket.emit('set_muted', {
            students: this.students.filter(function (s) {
              return s._id != student_id;
            }).map(function (s) {
              return s.socket;
            }),
            classroom_id: this.currentRoom,
            student_socket: this.students[index].socket,
            student_id: student_id,
            muted: muted
          });
        } else {
          this.socket.emit('give_attention', this.students[index].socket);
        }
      }
    }
  }
});

/***/ }),

/***/ 1205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header_teacher__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_footer__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_appBus__ = __webpack_require__(124);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'templateTeacher',
  data: function data() {
    return {
      showMenu: false
    };
  },

  methods: {
    setShowMenu: function setShowMenu(show) {
      this.showMenu = show;
    },
    goTo: function goTo(route) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setShowMenu(false);
                _context.next = 3;
                return _this.$delay(200);

              case 3:
                _this.$router.push({ name: route });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    logout: function logout() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.setShowMenu(false);
                _context2.next = 3;
                return _this2.$delay(200);

              case 3:
                _context2.next = 5;
                return _this2.$store.dispatch('auth/logout');

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  components: {
    teacherHeader: __WEBPACK_IMPORTED_MODULE_2__components_header_teacher__["default"],
    teacherFooter: __WEBPACK_IMPORTED_MODULE_3__components_footer__["default"]
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_4__plugins_appBus__["a" /* default */].$on('showMenu', this.setShowMenu);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_4__plugins_appBus__["a" /* default */].$off('showMenu', this.setShowMenu);
  }
});

/***/ }),

/***/ 1393:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1394);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("0ddc1bb7", content, true, {});

/***/ }),

/***/ 1394:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".align-center[data-v-1e3681b6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@-webkit-keyframes loadAudioPlayer-data-v-1e3681b6{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@keyframes loadAudioPlayer-data-v-1e3681b6{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@-webkit-keyframes loadAudioPlayerReset-data-v-1e3681b6{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}@keyframes loadAudioPlayerReset-data-v-1e3681b6{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}.animationLoadCircle[data-v-1e3681b6]{-webkit-animation-name:loadAudioPlayer-data-v-1e3681b6;animation-name:loadAudioPlayer-data-v-1e3681b6;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.animationLoadCircle.reset[data-v-1e3681b6]{animation-direction:reverse;-webkit-animation-duration:.5s;animation-duration:.5s}.classrooms[data-v-1e3681b6]{-webkit-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.classrooms__header[data-v-1e3681b6]{padding:0 10px}.classrooms__header[data-v-1e3681b6]:not(:first-child){padding:5px 10px;margin-bottom:10px}.classrooms__header__heading[data-v-1e3681b6]{text-align:left}.classrooms__header__heading--online[data-v-1e3681b6]{float:left;border:2px solid #57be29;border-radius:15px;color:#57be29;text-transform:uppercase;padding:1px 35px}.classrooms__box[data-v-1e3681b6]{-webkit-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:distribute;justify-content:space-around;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;border:5px solid #ccc!important;border-radius:15px;padding:5px 10px}.classrooms__box__item[data-v-1e3681b6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:5px 5px 10px;margin:5px 2px;border:3px solid #bbb;border-radius:5px;width:210px}.classrooms__box__item p.status[data-v-1e3681b6]{margin-top:5px}.classrooms__box__item button.open-classroom[data-v-1e3681b6]{margin-top:5px;border-radius:15px}.modal-call[data-v-1e3681b6]{overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:fixed;width:100vw;height:100vh;z-index:999;top:0;left:0;background-color:rgba(25,25,25,.95);color:#fff}.modal-call.modal-call__animation--open[data-v-1e3681b6]{-webkit-animation:open-data-v-1e3681b6 .8s ease-in;animation:open-data-v-1e3681b6 .8s ease-in}.modal-call.modal-call__animation--close[data-v-1e3681b6]{-webkit-animation:close-data-v-1e3681b6 .5s ease-out;animation:close-data-v-1e3681b6 .5s ease-out}.modal-call__talking[data-v-1e3681b6]{width:100%;height:100%;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-ms-flex-item-align:center;align-self:center;overflow:hidden;z-index:100}.modal-call__talking__box[data-v-1e3681b6]{height:calc(100% - 77px);max-height:calc(100% - 77px)}.modal-call__talking__classroomkey[data-v-1e3681b6]{color:#c2003c;font-size:32px;margin:20px auto}.modal-call__talking__streams[data-v-1e3681b6]{min-width:350px;padding:0 10px 10px;-webkit-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;max-height:100%}.modal-call__talking__streams__mine[data-v-1e3681b6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:auto;-webkit-box-flex:1;-ms-flex:1;flex:1;max-height:60%}.modal-call__talking__streams__mine__teacher[data-v-1e3681b6]{width:100%;height:auto}.modal-call__talking__streams__others[data-v-1e3681b6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-wrap:wrap;flex-wrap:wrap;max-height:40%;overflow-y:auto}.modal-call__talking__hangup[data-v-1e3681b6]{cursor:pointer;position:absolute;top:7px;right:20px;background-color:#c20030;color:#fff;padding:15px 13px;border-radius:150px}.modal-call__talking__hangup svg[data-v-1e3681b6]{font-size:30px}@media screen and (max-width:800px){.modal-call__talking__box[data-v-1e3681b6]{height:calc(100% - 35vh - 77px);max-height:calc(100% - 35vh - 77px)}.modal-call__talking__streams__mine[data-v-1e3681b6]{height:calc(100% - 175px);max-height:calc(100% - 175px)}.modal-call__talking__streams__others[data-v-1e3681b6]{height:175px;-ms-flex-wrap:nowrap;flex-wrap:nowrap}}@-webkit-keyframes open-data-v-1e3681b6{0%{-webkit-clip-path:circle(0 at 50% 50%);clip-path:circle(0 at 50% 50%);opacity:0}to{-webkit-clip-path:circle(100% at 50% 50%);clip-path:circle(100% at 50% 50%);opacity:1}}@keyframes open-data-v-1e3681b6{0%{-webkit-clip-path:circle(0 at 50% 50%);clip-path:circle(0 at 50% 50%);opacity:0}to{-webkit-clip-path:circle(100% at 50% 50%);clip-path:circle(100% at 50% 50%);opacity:1}}@-webkit-keyframes close-data-v-1e3681b6{0%{-webkit-clip-path:circle(100% at 50% 50%);clip-path:circle(100% at 50% 50%);opacity:1}to{-webkit-clip-path:circle(0 at 50% 50%);clip-path:circle(0 at 50% 50%);opacity:0}}@keyframes close-data-v-1e3681b6{0%{-webkit-clip-path:circle(100% at 50% 50%);clip-path:circle(100% at 50% 50%);opacity:1}to{-webkit-clip-path:circle(0 at 50% 50%);clip-path:circle(0 at 50% 50%);opacity:0}}@-webkit-keyframes calling-data-v-1e3681b6{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(2);transform:scale(2);opacity:0}}@keyframes calling-data-v-1e3681b6{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(2);transform:scale(2);opacity:0}}@-webkit-keyframes callingEntry-data-v-1e3681b6{0%{opacity:0;-webkit-transform:scale(0);transform:scale(0)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes callingEntry-data-v-1e3681b6{0%{opacity:0;-webkit-transform:scale(0);transform:scale(0)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/pages/teacher/home.vue"],"names":[],"mappings":"AACA,+BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,mDACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,2CACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,wDACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,gDACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,sCACE,uDAAwD,AAChD,+CAAgD,AACxD,qCAAsC,AAC9B,4BAA8B,CACvC,AACD,4CACI,4BAA6B,AAC7B,+BAAgC,AACxB,sBAAwB,CACnC,AACD,6BACE,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,qCACI,cAAgB,CACnB,AACD,uDACM,iBAAkB,AAClB,kBAAoB,CACzB,AACD,8CACM,eAAiB,CACtB,AACD,sDACQ,WAAY,AACZ,yBAA0B,AAC1B,mBAAoB,AACpB,cAAe,AACf,yBAA0B,AAC1B,gBAAkB,CACzB,AACD,kCACI,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,6BAA8B,AAClC,0BAA2B,AACvB,uBAAwB,AACpB,oBAAqB,AAC7B,gCAAkC,AAClC,mBAAoB,AACpB,gBAAkB,CACrB,AACD,wCACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,qBAA0B,AAC1B,eAAgB,AAChB,sBAAuB,AACvB,kBAAmB,AACnB,WAAa,CAClB,AACD,iDACQ,cAAgB,CACvB,AACD,8DACQ,eAAgB,AAChB,kBAAoB,CAC3B,AACD,6BACE,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,eAAgB,AAChB,YAAa,AACb,aAAc,AACd,YAAa,AACb,MAAO,AACP,OAAQ,AACR,oCAAyC,AACzC,UAAY,CACb,AACD,yDACI,mDAAoD,AAC5C,0CAA4C,CACvD,AACD,0DACI,qDAAsD,AAC9C,4CAA8C,CACzD,AACD,sCAEI,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,2BAA4B,AACxB,kBAAmB,AACvB,gBAAiB,AACjB,WAAa,CAChB,AACD,2CACM,yBAA0B,AAC1B,4BAA8B,CACnC,AACD,oDACM,cAAe,AACf,eAAgB,AAChB,gBAAkB,CACvB,AACD,+CACM,gBAAiB,AACjB,oBAA0B,AAC1B,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,eAAiB,CACtB,AACD,qDACQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,YAAa,AACb,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,cAAgB,CACvB,AACD,8DACU,WAAY,AACZ,WAAa,CACtB,AACD,uDACQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,mBAAoB,AAChB,eAAgB,AACpB,eAAgB,AAChB,eAAiB,CACxB,AACD,8CACM,eAAgB,AAChB,kBAAmB,AACnB,QAAS,AACT,WAAY,AACZ,yBAA0B,AAC1B,WAAY,AACZ,kBAAmB,AACnB,mBAAqB,CAC1B,AACD,kDACQ,cAAgB,CACvB,AACD,oCACA,2CACI,gCAAiC,AACjC,mCAAqC,CACxC,AACD,qDACI,0BAA2B,AAC3B,6BAA+B,CAClC,AACD,uDACI,aAAc,AACd,qBAAsB,AAClB,gBAAkB,CACzB,CACA,AACD,wCACA,GACI,uCAAyC,AACjC,+BAAiC,AACzC,SAAW,CACd,AACD,GACI,0CAA2C,AACnC,kCAAmC,AAC3C,SAAW,CACd,CACA,AACD,gCACA,GACI,uCAAyC,AACjC,+BAAiC,AACzC,SAAW,CACd,AACD,GACI,0CAA2C,AACnC,kCAAmC,AAC3C,SAAW,CACd,CACA,AACD,yCACA,GACI,0CAA2C,AACnC,kCAAmC,AAC3C,SAAW,CACd,AACD,GACI,uCAAyC,AACjC,+BAAiC,AACzC,SAAW,CACd,CACA,AACD,iCACA,GACI,0CAA2C,AACnC,kCAAmC,AAC3C,SAAW,CACd,AACD,GACI,uCAAyC,AACjC,+BAAiC,AACzC,SAAW,CACd,CACA,AACD,2CACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,SAAW,CACd,AACD,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,SAAW,CACd,CACA,AACD,mCACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,SAAW,CACd,AACD,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,SAAW,CACd,CACA,AACD,gDACA,GACI,UAAW,AACX,2BAA4B,AACpB,kBAAoB,CAC/B,AACD,GACI,UAAW,AACX,2BAA4B,AACpB,kBAAoB,CAC/B,CACA,AACD,wCACA,GACI,UAAW,AACX,2BAA4B,AACpB,kBAAoB,CAC/B,AACD,GACI,UAAW,AACX,2BAA4B,AACpB,kBAAoB,CAC/B,CACA","file":"home.vue","sourcesContent":["\n.align-center[data-v-1e3681b6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n@-webkit-keyframes loadAudioPlayer-data-v-1e3681b6 {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@keyframes loadAudioPlayer-data-v-1e3681b6 {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@-webkit-keyframes loadAudioPlayerReset-data-v-1e3681b6 {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n@keyframes loadAudioPlayerReset-data-v-1e3681b6 {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n.animationLoadCircle[data-v-1e3681b6] {\n  -webkit-animation-name: loadAudioPlayer-data-v-1e3681b6;\n          animation-name: loadAudioPlayer-data-v-1e3681b6;\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards;\n}\n.animationLoadCircle.reset[data-v-1e3681b6] {\n    animation-direction: reverse;\n    -webkit-animation-duration: .5s;\n            animation-duration: .5s;\n}\n.classrooms[data-v-1e3681b6] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.classrooms__header[data-v-1e3681b6] {\n    padding: 0 10px;\n}\n.classrooms__header[data-v-1e3681b6]:not(:first-child) {\n      padding: 5px 10px;\n      margin-bottom: 10px;\n}\n.classrooms__header__heading[data-v-1e3681b6] {\n      text-align: left;\n}\n.classrooms__header__heading--online[data-v-1e3681b6] {\n        float: left;\n        border: 2px solid #57BE29;\n        border-radius: 15px;\n        color: #57BE29;\n        text-transform: uppercase;\n        padding: 1px 35px;\n}\n.classrooms__box[data-v-1e3681b6] {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n    -webkit-box-align: stretch;\n        -ms-flex-align: stretch;\n            align-items: stretch;\n    border: 5px solid #ccc !important;\n    border-radius: 15px;\n    padding: 5px 10px;\n}\n.classrooms__box__item[data-v-1e3681b6] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      padding: 5px 5px 10px 5px;\n      margin: 5px 2px;\n      border: 3px solid #BBB;\n      border-radius: 5px;\n      width: 210px;\n}\n.classrooms__box__item p.status[data-v-1e3681b6] {\n        margin-top: 5px;\n}\n.classrooms__box__item button.open-classroom[data-v-1e3681b6] {\n        margin-top: 5px;\n        border-radius: 15px;\n}\n.modal-call[data-v-1e3681b6] {\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  z-index: 999;\n  top: 0;\n  left: 0;\n  background-color: rgba(25, 25, 25, 0.95);\n  color: #fff;\n}\n.modal-call.modal-call__animation--open[data-v-1e3681b6] {\n    -webkit-animation: open-data-v-1e3681b6 .8s ease-in;\n            animation: open-data-v-1e3681b6 .8s ease-in;\n}\n.modal-call.modal-call__animation--close[data-v-1e3681b6] {\n    -webkit-animation: close-data-v-1e3681b6 .5s ease-out;\n            animation: close-data-v-1e3681b6 .5s ease-out;\n}\n.modal-call__talking[data-v-1e3681b6] {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -ms-flex-item-align: center;\n        align-self: center;\n    overflow: hidden;\n    z-index: 100;\n}\n.modal-call__talking__box[data-v-1e3681b6] {\n      height: calc(100% - 77px);\n      max-height: calc(100% - 77px);\n}\n.modal-call__talking__classroomkey[data-v-1e3681b6] {\n      color: #C2003C;\n      font-size: 32px;\n      margin: 20px auto;\n}\n.modal-call__talking__streams[data-v-1e3681b6] {\n      min-width: 350px;\n      padding: 0 10px 10px 10px;\n      -webkit-box-flex: 1;\n          -ms-flex: 1;\n              flex: 1;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      max-height: 100%;\n}\n.modal-call__talking__streams__mine[data-v-1e3681b6] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        height: auto;\n        -webkit-box-flex: 1;\n            -ms-flex: 1;\n                flex: 1;\n        max-height: 60%;\n}\n.modal-call__talking__streams__mine__teacher[data-v-1e3681b6] {\n          width: 100%;\n          height: auto;\n}\n.modal-call__talking__streams__others[data-v-1e3681b6] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        max-height: 40%;\n        overflow-y: auto;\n}\n.modal-call__talking__hangup[data-v-1e3681b6] {\n      cursor: pointer;\n      position: absolute;\n      top: 7px;\n      right: 20px;\n      background-color: #C20030;\n      color: #fff;\n      padding: 15px 13px;\n      border-radius: 150px;\n}\n.modal-call__talking__hangup svg[data-v-1e3681b6] {\n        font-size: 30px;\n}\n@media screen and (max-width: 800px) {\n.modal-call__talking__box[data-v-1e3681b6] {\n    height: calc(100% - 35vh - 77px);\n    max-height: calc(100% - 35vh - 77px);\n}\n.modal-call__talking__streams__mine[data-v-1e3681b6] {\n    height: calc(100% - 175px);\n    max-height: calc(100% - 175px);\n}\n.modal-call__talking__streams__others[data-v-1e3681b6] {\n    height: 175px;\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n}\n}\n@-webkit-keyframes open-data-v-1e3681b6 {\n0% {\n    -webkit-clip-path: circle(0% at 50% 50%);\n            clip-path: circle(0% at 50% 50%);\n    opacity: 0;\n}\n100% {\n    -webkit-clip-path: circle(100% at 50% 50%);\n            clip-path: circle(100% at 50% 50%);\n    opacity: 1;\n}\n}\n@keyframes open-data-v-1e3681b6 {\n0% {\n    -webkit-clip-path: circle(0% at 50% 50%);\n            clip-path: circle(0% at 50% 50%);\n    opacity: 0;\n}\n100% {\n    -webkit-clip-path: circle(100% at 50% 50%);\n            clip-path: circle(100% at 50% 50%);\n    opacity: 1;\n}\n}\n@-webkit-keyframes close-data-v-1e3681b6 {\n0% {\n    -webkit-clip-path: circle(100% at 50% 50%);\n            clip-path: circle(100% at 50% 50%);\n    opacity: 1;\n}\n100% {\n    -webkit-clip-path: circle(0% at 50% 50%);\n            clip-path: circle(0% at 50% 50%);\n    opacity: 0;\n}\n}\n@keyframes close-data-v-1e3681b6 {\n0% {\n    -webkit-clip-path: circle(100% at 50% 50%);\n            clip-path: circle(100% at 50% 50%);\n    opacity: 1;\n}\n100% {\n    -webkit-clip-path: circle(0% at 50% 50%);\n            clip-path: circle(0% at 50% 50%);\n    opacity: 0;\n}\n}\n@-webkit-keyframes calling-data-v-1e3681b6 {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1;\n}\n100% {\n    -webkit-transform: scale(2);\n            transform: scale(2);\n    opacity: 0;\n}\n}\n@keyframes calling-data-v-1e3681b6 {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1;\n}\n100% {\n    -webkit-transform: scale(2);\n            transform: scale(2);\n    opacity: 0;\n}\n}\n@-webkit-keyframes callingEntry-data-v-1e3681b6 {\n0% {\n    opacity: 0;\n    -webkit-transform: scale(0);\n            transform: scale(0);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n}\n}\n@keyframes callingEntry-data-v-1e3681b6 {\n0% {\n    opacity: 0;\n    -webkit-transform: scale(0);\n            transform: scale(0);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1395:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1396), __esModule: true };

/***/ }),

/***/ 1396:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(9);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ 1397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacher_vue__ = __webpack_require__(1205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5193860_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_teacher_vue__ = __webpack_require__(1400);
function injectStyle (ssrContext) {
  __webpack_require__(1398)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5193860"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5193860_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_teacher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1398:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1399);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("0ca8c013", content, true, {});

/***/ }),

/***/ 1399:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".main__menu[data-v-b5193860]{position:absolute;top:0;left:0;background-color:rgba(30,0,0,.9);width:100vw;height:100vh;z-index:150;display:-webkit-box;display:-ms-flexbox;display:flex}.main__menu__icon[data-v-b5193860]{position:absolute;top:5vh;right:5vw;height:60px;width:60px;color:#ff7878;-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s;cursor:pointer}.main__menu__icon[data-v-b5193860]:hover{-webkit-transform:scale(1.2) rotate(90deg);transform:scale(1.2) rotate(90deg)}.main__menu ul[data-v-b5193860]{list-style-type:none;margin:0 auto;margin-top:25vh;text-align:center}.main__menu ul li[data-v-b5193860]{-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s;font-size:35px;font-weight:300;letter-spacing:1px;color:#ccc;cursor:pointer}.main__menu ul li[data-v-b5193860]:hover{-webkit-transform:scale(1.2) translateY(-10px);transform:scale(1.2) translateY(-10px)}.show-menu-enter-active[data-v-b5193860]{-webkit-animation:opaque-data-v-b5193860 .2s ease backwards;animation:opaque-data-v-b5193860 .2s ease backwards;-webkit-animation-delay:.2s;animation-delay:.2s}.show-menu-leave-active[data-v-b5193860]{animation:opaque-data-v-b5193860 .2s ease reverse backwards}@-webkit-keyframes opaque-data-v-b5193860{0%{opacity:0}to{opacity:1}}@keyframes opaque-data-v-b5193860{0%{opacity:0}to{opacity:1}}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/template/teacher.vue"],"names":[],"mappings":"AACA,6BACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,iCAAsC,AACtC,YAAa,AACb,aAAc,AACd,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,mCACI,kBAAmB,AACnB,QAAS,AACT,UAAW,AACX,YAAa,AACb,WAAY,AACZ,cAAe,AACf,yCAA0C,AAC1C,iCAAkC,AAClC,yBAA0B,AAC1B,+CAAiD,AACjD,cAAgB,CACnB,AACD,yCACM,2CAA4C,AACpC,kCAAoC,CACjD,AACD,gCACI,qBAAsB,AACtB,cAAe,AACf,gBAAiB,AACjB,iBAAmB,CACtB,AACD,mCACM,yCAA0C,AAC1C,iCAAkC,AAClC,yBAA0B,AAC1B,+CAAiD,AACjD,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,WAAY,AACZ,cAAgB,CACrB,AACD,yCACQ,+CAAgD,AACxC,sCAAwC,CACvD,AACD,yCACE,4DAA6D,AACrD,oDAAqD,AAC7D,4BAA6B,AACrB,mBAAqB,CAC9B,AACD,yCACE,2DAA6D,CAC9D,AACD,0CACA,GACI,SAAW,CACd,AACD,GACI,SAAW,CACd,CACA,AACD,kCACA,GACI,SAAW,CACd,AACD,GACI,SAAW,CACd,CACA","file":"teacher.vue","sourcesContent":["\n.main__menu[data-v-b5193860] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: rgba(30, 0, 0, 0.9);\n  width: 100vw;\n  height: 100vh;\n  z-index: 150;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.main__menu__icon[data-v-b5193860] {\n    position: absolute;\n    top: 5vh;\n    right: 5vw;\n    height: 60px;\n    width: 60px;\n    color: #ff7878;\n    -webkit-transition: -webkit-transform .2s;\n    transition: -webkit-transform .2s;\n    transition: transform .2s;\n    transition: transform .2s, -webkit-transform .2s;\n    cursor: pointer;\n}\n.main__menu__icon[data-v-b5193860]:hover {\n      -webkit-transform: scale(1.2) rotate(90deg);\n              transform: scale(1.2) rotate(90deg);\n}\n.main__menu ul[data-v-b5193860] {\n    list-style-type: none;\n    margin: 0 auto;\n    margin-top: 25vh;\n    text-align: center;\n}\n.main__menu ul li[data-v-b5193860] {\n      -webkit-transition: -webkit-transform .2s;\n      transition: -webkit-transform .2s;\n      transition: transform .2s;\n      transition: transform .2s, -webkit-transform .2s;\n      font-size: 35px;\n      font-weight: 300;\n      letter-spacing: 1px;\n      color: #CCC;\n      cursor: pointer;\n}\n.main__menu ul li[data-v-b5193860]:hover {\n        -webkit-transform: scale(1.2) translateY(-10px);\n                transform: scale(1.2) translateY(-10px);\n}\n.show-menu-enter-active[data-v-b5193860] {\n  -webkit-animation: opaque-data-v-b5193860 .2s ease backwards;\n          animation: opaque-data-v-b5193860 .2s ease backwards;\n  -webkit-animation-delay: .2s;\n          animation-delay: .2s;\n}\n.show-menu-leave-active[data-v-b5193860] {\n  animation: opaque-data-v-b5193860 .2s ease reverse backwards;\n}\n@-webkit-keyframes opaque-data-v-b5193860 {\nfrom {\n    opacity: 0;\n}\nto {\n    opacity: 1;\n}\n}\n@keyframes opaque-data-v-b5193860 {\nfrom {\n    opacity: 0;\n}\nto {\n    opacity: 1;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1400:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('teacherHeader'),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('teacherFooter'),_vm._v(" "),_c('transition',{attrs:{"name":"show-menu"}},[(_vm.showMenu)?_c('div',{staticClass:"main__menu"},[_c('font-awesome-icon',{staticClass:"main__menu__icon",attrs:{"icon":"times"},on:{"click":function($event){return _vm.setShowMenu(false)}}}),_vm._v(" "),_c('ul',[_c('li',{on:{"click":function($event){return _vm.goTo('perfil')}}},[_vm._v("Perfil")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.logout()}}},[_vm._v("Logout")])])],1):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('teacherTemplate',[_c('div',{staticClass:"size margin container align-items-stretch wrap justify-content-center relative"},[_c('div',{staticClass:"col-12 col-xl-9 col-lg-9 col-md-8 col-sm-12 container column"},[_c('div',{staticClass:"box-content--header container align-items-center justify-content-center hidden"},[_c('div',{staticClass:"box-content--header__img"},[_c('div',{staticClass:"img1 container align-items-center justify-content-center animation-bottom"},[_c('div',{staticClass:"img2 container align-items-center justify-content-center"},[_c('img',{attrs:{"src":__webpack_require__(658),"width":"50","alt":"Minds"}})])])]),_vm._v(" "),_c('div',{staticClass:"box-content--header__text flex-grow-1 flex-basis-400"},[_c('h2',{staticClass:"animation-top animation-delay-02"},[_vm._v("PERSONAL "),_c('span',[_vm._v("TEACHER")])]),_vm._v(" "),_c('hr',{staticClass:"header-text-hr animation-top animation-delay-02"}),_vm._v(" "),_c('p',{staticClass:"animation-bottom animation-delay-04"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]),_vm._v(" "),_c('div',{staticClass:"box-content shadow-box box-content-border hidden"},[_c('div',{staticClass:"container box--item animation-bottom animation-delay-05"},[_c('div',{staticClass:"classrooms"},[_c('div',{staticClass:"classrooms__header"},[_c('h3',{staticClass:"classrooms__header__heading"},[_vm._v("Classrooms")])]),_vm._v(" "),_c('div',{staticClass:"classrooms__header"},[_c('span',{staticClass:"classrooms__header__heading classrooms__header__heading--online"},[_vm._v("online")])]),_vm._v(" "),(!_vm.classrooms.length)?_c('div',{staticClass:"classrooms__box container justify-content-center align-items-center"},[_c('h4',{staticStyle:{"padding":"0px 10px"}},[_vm._v("No classroom")])]):_c('div',{staticClass:"classrooms__box"},_vm._l((_vm.classrooms),function(classroom,index){return _c('div',{staticClass:"classrooms__box__item"},[_c('p'),_c('h5',[_vm._v("Classroom "+_vm._s(index + 1))]),_c('p'),_vm._v(" "),_c('p',[_vm._v("Status: "),_c('b',[_vm._v(_vm._s(classroom.active ? 'ACTIVE' : 'EXPIRED'))])]),_vm._v(" "),(classroom.teacher)?_c('p',[_vm._v("Used by: "+_vm._s(classroom.teacher))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"open-classroom btn btn-sm btn-green",attrs:{"disabled":(classroom.teacher_id != _vm.teacher._id && (classroom.busy || !classroom.active)) || _vm.creating},on:{"click":function($event){return _vm.getStream(classroom._id, !!classroom.teacher_id, classroom.classroom_key)}}},[_vm._v("\n                  "+_vm._s((classroom.teacher_id == _vm.teacher._id) ? 'Join' : 'Open')+" Classroom\n                ")])])}),0)])])])])]),_vm._v(" "),(_vm.show)?_c('div',{ref:"modal",staticClass:"modal-call modal-call__animation--open"},[_c('div',{staticClass:"modal-call__talking"},[_c('span',{staticClass:"modal-call__talking__classroomkey"},[_vm._v(_vm._s(_vm.classroomKey))]),_vm._v(" "),_c('div',{staticClass:"container wrap modal-call__talking__box"},[_c('div',{staticClass:"modal-call__talking__streams"},[_c('div',{staticClass:"modal-call__talking__streams__mine"},[_c('video',{ref:"teacher_video",staticClass:"modal-call__talking__streams__mine__teacher",attrs:{"autoplay":"","muted":""},domProps:{"muted":true}})]),_vm._v(" "),_c('div',{staticClass:"modal-call__talking__streams__others"},_vm._l((_vm.students),function(student){return _c('student-video-chat',{key:student._id,ref:("student_video_" + (student._id)),refInFor:true,attrs:{"student":student,"canMute":true,"setMuted":_vm.setMuted}})}),1)]),_vm._v(" "),_c('chat-box',{attrs:{"chat":_vm.chat,"person":_vm.teacher._id,"sendMessage":_vm.sendMessage,"hasStream":false}})],1),_vm._v(" "),_c('div',{staticClass:"modal-call__talking__hangup"},[_c('div',{staticClass:"modal-call__talking__hangup__icon",on:{"click":function($event){return _vm.closeClassroom()}}},[_c('font-awesome-icon',{attrs:{"icon":"phone-slash"}})],1)])]),_vm._v(" "),_c('audio',{ref:"alert-beep",staticStyle:{"display":"none"},attrs:{"src":__webpack_require__(871)}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(680);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e9ed4e_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(770);
function injectStyle (ssrContext) {
  __webpack_require__(768)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31e9ed4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e9ed4e_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacher_vue__ = __webpack_require__(885);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27f506d2_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_teacher_vue__ = __webpack_require__(982);
function injectStyle (ssrContext) {
  __webpack_require__(980)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27f506d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27f506d2_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_teacher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__(1204);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e3681b6_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__(1401);
function injectStyle (ssrContext) {
  __webpack_require__(1393)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e3681b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e3681b6_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 658:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjRkZERDA5IiBkPSJNMy43NjIgNDguOTRoNDEuNTUzVjQuNjE3SDMuNzYyeiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0uOTkyIDQ4Ljk0aDIuNzdWNC42MTdILjk5MnoiLz48cGF0aCBmaWxsPSIjRkQ5ODA4IiBkPSJNNDUuMzE1IDguMzF2NDAuNjNINC42ODV2My42OTNoNDQuMzIzVjguMzF6Ii8+PHBhdGggZmlsbD0iI0ZDQzMwOSIgZD0iTTQuNjg1IDUyLjYzM2g0MS41NTNWNDguOTRINC42ODV6Ii8+PHBhdGggZD0iTTQ1LjMxNSA0OS44NjNILjk5MmMtLjU1NCAwLS45MjMtLjM3LS45MjMtLjkyM1Y0LjYxN2MwLS41NTQuMzY5LS45MjMuOTIzLS45MjNoNDQuMzIzYy41NTQgMCAuOTIzLjM2OS45MjMuOTIzVjQ4Ljk0YzAgLjU1NC0uMzcuOTIzLS45MjMuOTIzem0tNDMuNC0xLjg0N2g0Mi40NzZWNS41NEgxLjkxNXY0Mi40NzZ6IiBmaWxsPSIjMDAwIi8+PHBhdGggZD0iTTQ5LjAwOCA1My41NTZINC42ODVjLS41NTQgMC0uOTIzLS4zNjktLjkyMy0uOTIzVjQ4Ljk0YzAtLjU1NS4zNy0uOTI0LjkyMy0uOTI0aDM5LjcwNlY4LjMxYzAtLjU1NC4zNy0uOTIzLjkyNC0uOTIzaDMuNjkzYy41NTQgMCAuOTIzLjM3LjkyMy45MjN2NDQuMzIzYzAgLjU1NC0uMzY5LjkyMy0uOTIzLjkyM3ptLTQzLjQtMS44NDZoNDIuNDc3VjkuMjM0aC0xLjg0N1Y0OC45NGMwIC41NTQtLjM3LjkyMy0uOTIzLjkyM0g1LjYwOXYxLjg0N3ptMTUuNjk4LTM4Ljc4M2EzLjcwNCAzLjcwNCAwIDAgMS0zLjY5My0zLjY5M3YtNS41NEEzLjcwNCAzLjcwNCAwIDAgMSAyMS4zMDYgMCAzLjcwNCAzLjcwNCAwIDAgMSAyNSAzLjY5NGMwIC41NTQtLjM3LjkyMy0uOTIzLjkyMy0uNTU1IDAtLjkyNC0uMzctLjkyNC0uOTIzYTEuODUyIDEuODUyIDAgMCAwLTEuODQ3LTEuODQ3IDEuODUyIDEuODUyIDAgMCAwLTEuODQ2IDEuODQ3djUuNTRjMCAxLjAxNi44MyAxLjg0NyAxLjg0NiAxLjg0N2ExLjg1MiAxLjg1MiAwIDAgMCAxLjg0Ny0xLjg0N2MwLS41NTQuMzctLjkyNC45MjQtLjkyNHMuOTIzLjM3LjkyMy45MjRhMy43MDQgMy43MDQgMCAwIDEtMy42OTQgMy42OTN6IiBmaWxsPSIjMDAwIi8+PHBhdGggZD0iTTM2LjA4IDIwLjMxNWgtMy42OTNjLS41NTQgMC0uOTIzLS4zNy0uOTIzLS45MjRzLjM3LS45MjMuOTIzLS45MjNoMy42OTRjLjU1NCAwIC45MjMuMzY5LjkyMy45MjNzLS4zNy45MjQtLjkyMy45MjR6bS03LjM4NiAwSDIyLjIzYy0uNTU0IDAtLjkyNC0uMzctLjkyNC0uOTI0cy4zNy0uOTIzLjkyNC0uOTIzaDYuNDY0Yy41NTQgMCAuOTIzLjM2OS45MjMuOTIzcy0uMzcuOTI0LS45MjMuOTI0em0tMTAuMTU4IDBoLTguMzFjLS41NTQgMC0uOTI0LS4zNy0uOTI0LS45MjRzLjM3LS45MjMuOTI0LS45MjNoOC4zMWMuNTU0IDAgLjkyNC4zNjkuOTI0LjkyM3MtLjM3LjkyNC0uOTI0LjkyNHptMTcuNTQ0IDUuNTRoLTcuMzg2Yy0uNTU1IDAtLjkyNC0uMzctLjkyNC0uOTI0cy4zNy0uOTIzLjkyNC0uOTIzaDcuMzg3Yy41NTQgMCAuOTIzLjM3LjkyMy45MjMgMCAuNTU0LS4zNy45MjQtLjkyMy45MjR6bS0xMi45MjcgMEgxNi42OWMtLjU1NSAwLS45MjQtLjM3LS45MjQtLjkyNHMuMzctLjkyMy45MjQtLjkyM2g2LjQ2M2MuNTU0IDAgLjkyNC4zNy45MjQuOTIzIDAgLjU1NC0uMzcuOTI0LS45MjQuOTI0em0tMTAuMTU3IDBoLTIuNzdjLS41NTQgMC0uOTI0LS4zNy0uOTI0LS45MjRzLjM3LS45MjMuOTI0LS45MjNoMi43N2MuNTU0IDAgLjkyMy4zNy45MjMuOTIzIDAgLjU1NC0uMzY5LjkyNC0uOTIzLjkyNHptMjMuMDg0IDUuNTRoLTIuNzdjLS41NTQgMC0uOTIzLS4zNy0uOTIzLS45MjMgMC0uNTU0LjM3LS45MjQuOTIzLS45MjRoMi43N2MuNTU1IDAgLjkyNC4zNy45MjQuOTI0cy0uMzcuOTIzLS45MjMuOTIzem0tNi40NjMgMGgtOS4yMzRjLS41NTQgMC0uOTIzLS4zNy0uOTIzLS45MjMgMC0uNTU0LjM2OS0uOTI0LjkyMy0uOTI0aDkuMjM0Yy41NTQgMCAuOTIzLjM3LjkyMy45MjRzLS4zNy45MjMtLjkyMy45MjN6bS0xNC43NzQgMGgtNC42MTdjLS41NTQgMC0uOTI0LS4zNy0uOTI0LS45MjMgMC0uNTU0LjM3LS45MjQuOTI0LS45MjRoNC42MTdjLjU1NCAwIC45MjMuMzcuOTIzLjkyNHMtLjM3LjkyMy0uOTIzLjkyM3ptMjEuMjM3IDUuNTRIMjUuOTI0Yy0uNTU0IDAtLjkyMy0uMzY5LS45MjMtLjkyM3MuMzctLjkyMy45MjMtLjkyM2gxMC4xNThjLjU1NCAwIC45MjMuMzY5LjkyMy45MjNzLS4zNy45MjMtLjkyMy45MjN6bS0xNS42OTcgMEgxNi42OWMtLjU1NSAwLS45MjQtLjM2OS0uOTI0LS45MjNzLjM3LS45MjMuOTI0LS45MjNoMy42OTNjLjU1NCAwIC45MjMuMzY5LjkyMy45MjNzLS4zNjkuOTIzLS45MjMuOTIzem0tNy4zODcgMGgtMi43N2MtLjU1NCAwLS45MjQtLjM2OS0uOTI0LS45MjNzLjM3LS45MjMuOTI0LS45MjNoMi43N2MuNTU0IDAgLjkyMy4zNjkuOTIzLjkyM3MtLjM2OS45MjMtLjkyMy45MjN6IiBmaWxsPSIjMDAwIi8+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.0617d53.svg";

/***/ }),

/***/ 670:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 671:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(772);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ 678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_appBus__ = __webpack_require__(124);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'userContent',
  data: function data() {
    return {
      student: {
        image: 'user',
        imageType: 'png'
      }
    };
  },

  props: {
    data: {
      type: Object,
      default: { name: 'Default' }
    }
  },
  computed: {
    user: function user() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.student, this.data);
    }
  },
  methods: {
    showMenu: function showMenu() {
      __WEBPACK_IMPORTED_MODULE_1__plugins_appBus__["a" /* default */].$emit('showMenu', true);
    }
  }
});

/***/ }),

/***/ 680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    year: function year() {
      var today = new Date();

      return today.getUTCFullYear();
    }
  }
});

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};

  var args = new Array(arguments.length - 1)
    , callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var keys = __webpack_require__(1014);
var hasBinary = __webpack_require__(923);
var sliceBuffer = __webpack_require__(1016);
var after = __webpack_require__(1017);
var utf8 = __webpack_require__(1018);

var base64encoder;
if (typeof ArrayBuffer !== 'undefined') {
  base64encoder = __webpack_require__(1019);
}

/**
 * Check if we are running an android browser. That requires us to use
 * ArrayBuffer with polling transports...
 *
 * http://ghinda.net/jpeg-blob-ajax-android/
 */

var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

/**
 * Check if we are running in PhantomJS.
 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
 * https://github.com/ariya/phantomjs/issues/11395
 * @type boolean
 */
var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);

/**
 * When true, avoids using Blobs to encode payloads.
 * @type boolean
 */
var dontSendBlobs = isAndroid || isPhantomJS;

/**
 * Current protocol version.
 */

exports.protocol = 3;

/**
 * Packet types.
 */

var packets = exports.packets = {
    open:     0    // non-ws
  , close:    1    // non-ws
  , ping:     2
  , pong:     3
  , message:  4
  , upgrade:  5
  , noop:     6
};

var packetslist = keys(packets);

/**
 * Premade error packet.
 */

var err = { type: 'error', data: 'parser error' };

/**
 * Create a blob api even for blob builder when vendor prefixes exist
 */

var Blob = __webpack_require__(1020);

/**
 * Encodes a packet.
 *
 *     <packet type id> [ <data> ]
 *
 * Example:
 *
 *     5hello world
 *     3
 *     4
 *
 * Binary is encoded in an identical principle
 *
 * @api private
 */

exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = false;
  }

  if (typeof utf8encode === 'function') {
    callback = utf8encode;
    utf8encode = null;
  }

  var data = (packet.data === undefined)
    ? undefined
    : packet.data.buffer || packet.data;

  if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) {
    return encodeArrayBuffer(packet, supportsBinary, callback);
  } else if (typeof Blob !== 'undefined' && data instanceof Blob) {
    return encodeBlob(packet, supportsBinary, callback);
  }

  // might be an object with { base64: true, data: dataAsBase64String }
  if (data && data.base64) {
    return encodeBase64Object(packet, callback);
  }

  // Sending data as a utf-8 string
  var encoded = packets[packet.type];

  // data fragment is optional
  if (undefined !== packet.data) {
    encoded += utf8encode ? utf8.encode(String(packet.data), { strict: false }) : String(packet.data);
  }

  return callback('' + encoded);

};

function encodeBase64Object(packet, callback) {
  // packet data is an object { base64: true, data: dataAsBase64String }
  var message = 'b' + exports.packets[packet.type] + packet.data.data;
  return callback(message);
}

/**
 * Encode packet helpers for binary types
 */

function encodeArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var data = packet.data;
  var contentArray = new Uint8Array(data);
  var resultBuffer = new Uint8Array(1 + data.byteLength);

  resultBuffer[0] = packets[packet.type];
  for (var i = 0; i < contentArray.length; i++) {
    resultBuffer[i+1] = contentArray[i];
  }

  return callback(resultBuffer.buffer);
}

function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var fr = new FileReader();
  fr.onload = function() {
    exports.encodePacket({ type: packet.type, data: fr.result }, supportsBinary, true, callback);
  };
  return fr.readAsArrayBuffer(packet.data);
}

function encodeBlob(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  if (dontSendBlobs) {
    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
  }

  var length = new Uint8Array(1);
  length[0] = packets[packet.type];
  var blob = new Blob([length.buffer, packet.data]);

  return callback(blob);
}

/**
 * Encodes a packet with binary data in a base64 string
 *
 * @param {Object} packet, has `type` and `data`
 * @return {String} base64 encoded message
 */

exports.encodeBase64Packet = function(packet, callback) {
  var message = 'b' + exports.packets[packet.type];
  if (typeof Blob !== 'undefined' && packet.data instanceof Blob) {
    var fr = new FileReader();
    fr.onload = function() {
      var b64 = fr.result.split(',')[1];
      callback(message + b64);
    };
    return fr.readAsDataURL(packet.data);
  }

  var b64data;
  try {
    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
  } catch (e) {
    // iPhone Safari doesn't let you apply with typed arrays
    var typed = new Uint8Array(packet.data);
    var basic = new Array(typed.length);
    for (var i = 0; i < typed.length; i++) {
      basic[i] = typed[i];
    }
    b64data = String.fromCharCode.apply(null, basic);
  }
  message += btoa(b64data);
  return callback(message);
};

/**
 * Decodes a packet. Changes format to Blob if requested.
 *
 * @return {Object} with `type` and `data` (if any)
 * @api private
 */

exports.decodePacket = function (data, binaryType, utf8decode) {
  if (data === undefined) {
    return err;
  }
  // String data
  if (typeof data === 'string') {
    if (data.charAt(0) === 'b') {
      return exports.decodeBase64Packet(data.substr(1), binaryType);
    }

    if (utf8decode) {
      data = tryDecode(data);
      if (data === false) {
        return err;
      }
    }
    var type = data.charAt(0);

    if (Number(type) != type || !packetslist[type]) {
      return err;
    }

    if (data.length > 1) {
      return { type: packetslist[type], data: data.substring(1) };
    } else {
      return { type: packetslist[type] };
    }
  }

  var asArray = new Uint8Array(data);
  var type = asArray[0];
  var rest = sliceBuffer(data, 1);
  if (Blob && binaryType === 'blob') {
    rest = new Blob([rest]);
  }
  return { type: packetslist[type], data: rest };
};

function tryDecode(data) {
  try {
    data = utf8.decode(data, { strict: false });
  } catch (e) {
    return false;
  }
  return data;
}

/**
 * Decodes a packet encoded in a base64 string
 *
 * @param {String} base64 encoded message
 * @return {Object} with `type` and `data` (if any)
 */

exports.decodeBase64Packet = function(msg, binaryType) {
  var type = packetslist[msg.charAt(0)];
  if (!base64encoder) {
    return { type: type, data: { base64: true, data: msg.substr(1) } };
  }

  var data = base64encoder.decode(msg.substr(1));

  if (binaryType === 'blob' && Blob) {
    data = new Blob([data]);
  }

  return { type: type, data: data };
};

/**
 * Encodes multiple messages (payload).
 *
 *     <length>:data
 *
 * Example:
 *
 *     11:hello world2:hi
 *
 * If any contents are binary, they will be encoded as base64 strings. Base64
 * encoded strings are marked with a b before the length specifier
 *
 * @param {Array} packets
 * @api private
 */

exports.encodePayload = function (packets, supportsBinary, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = null;
  }

  var isBinary = hasBinary(packets);

  if (supportsBinary && isBinary) {
    if (Blob && !dontSendBlobs) {
      return exports.encodePayloadAsBlob(packets, callback);
    }

    return exports.encodePayloadAsArrayBuffer(packets, callback);
  }

  if (!packets.length) {
    return callback('0:');
  }

  function setLengthHeader(message) {
    return message.length + ':' + message;
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
      doneCallback(null, setLengthHeader(message));
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(results.join(''));
  });
};

/**
 * Async array map using after
 */

function map(ary, each, done) {
  var result = new Array(ary.length);
  var next = after(ary.length, done);

  var eachWithIndex = function(i, el, cb) {
    each(el, function(error, msg) {
      result[i] = msg;
      cb(error, result);
    });
  };

  for (var i = 0; i < ary.length; i++) {
    eachWithIndex(i, ary[i], next);
  }
}

/*
 * Decodes data when a payload is maybe expected. Possible binary contents are
 * decoded from their base64 representation
 *
 * @param {String} data, callback method
 * @api public
 */

exports.decodePayload = function (data, binaryType, callback) {
  if (typeof data !== 'string') {
    return exports.decodePayloadAsBinary(data, binaryType, callback);
  }

  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var packet;
  if (data === '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

  var length = '', n, msg;

  for (var i = 0, l = data.length; i < l; i++) {
    var chr = data.charAt(i);

    if (chr !== ':') {
      length += chr;
      continue;
    }

    if (length === '' || (length != (n = Number(length)))) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    msg = data.substr(i + 1, n);

    if (length != msg.length) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    if (msg.length) {
      packet = exports.decodePacket(msg, binaryType, false);

      if (err.type === packet.type && err.data === packet.data) {
        // parser error in individual packet - ignoring payload
        return callback(err, 0, 1);
      }

      var ret = callback(packet, i + n, l);
      if (false === ret) return;
    }

    // advance cursor
    i += n;
    length = '';
  }

  if (length !== '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

};

/**
 * Encodes multiple messages (payload) as binary.
 *
 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
 * 255><data>
 *
 * Example:
 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
 *
 * @param {Array} packets
 * @return {ArrayBuffer} encoded payload
 * @api private
 */

exports.encodePayloadAsArrayBuffer = function(packets, callback) {
  if (!packets.length) {
    return callback(new ArrayBuffer(0));
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(data) {
      return doneCallback(null, data);
    });
  }

  map(packets, encodeOne, function(err, encodedPackets) {
    var totalLength = encodedPackets.reduce(function(acc, p) {
      var len;
      if (typeof p === 'string'){
        len = p.length;
      } else {
        len = p.byteLength;
      }
      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
    }, 0);

    var resultArray = new Uint8Array(totalLength);

    var bufferIndex = 0;
    encodedPackets.forEach(function(p) {
      var isString = typeof p === 'string';
      var ab = p;
      if (isString) {
        var view = new Uint8Array(p.length);
        for (var i = 0; i < p.length; i++) {
          view[i] = p.charCodeAt(i);
        }
        ab = view.buffer;
      }

      if (isString) { // not true binary
        resultArray[bufferIndex++] = 0;
      } else { // true binary
        resultArray[bufferIndex++] = 1;
      }

      var lenStr = ab.byteLength.toString();
      for (var i = 0; i < lenStr.length; i++) {
        resultArray[bufferIndex++] = parseInt(lenStr[i]);
      }
      resultArray[bufferIndex++] = 255;

      var view = new Uint8Array(ab);
      for (var i = 0; i < view.length; i++) {
        resultArray[bufferIndex++] = view[i];
      }
    });

    return callback(resultArray.buffer);
  });
};

/**
 * Encode as Blob
 */

exports.encodePayloadAsBlob = function(packets, callback) {
  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(encoded) {
      var binaryIdentifier = new Uint8Array(1);
      binaryIdentifier[0] = 1;
      if (typeof encoded === 'string') {
        var view = new Uint8Array(encoded.length);
        for (var i = 0; i < encoded.length; i++) {
          view[i] = encoded.charCodeAt(i);
        }
        encoded = view.buffer;
        binaryIdentifier[0] = 0;
      }

      var len = (encoded instanceof ArrayBuffer)
        ? encoded.byteLength
        : encoded.size;

      var lenStr = len.toString();
      var lengthAry = new Uint8Array(lenStr.length + 1);
      for (var i = 0; i < lenStr.length; i++) {
        lengthAry[i] = parseInt(lenStr[i]);
      }
      lengthAry[lenStr.length] = 255;

      if (Blob) {
        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
        doneCallback(null, blob);
      }
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(new Blob(results));
  });
};

/*
 * Decodes data when a payload is maybe expected. Strings are decoded by
 * interpreting each byte as a key code for entries marked to start with 0. See
 * description of encodePayloadAsBinary
 *
 * @param {ArrayBuffer} data, callback method
 * @api public
 */

exports.decodePayloadAsBinary = function (data, binaryType, callback) {
  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var bufferTail = data;
  var buffers = [];

  while (bufferTail.byteLength > 0) {
    var tailArray = new Uint8Array(bufferTail);
    var isString = tailArray[0] === 0;
    var msgLength = '';

    for (var i = 1; ; i++) {
      if (tailArray[i] === 255) break;

      // 310 = char length of Number.MAX_VALUE
      if (msgLength.length > 310) {
        return callback(err, 0, 1);
      }

      msgLength += tailArray[i];
    }

    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
    msgLength = parseInt(msgLength);

    var msg = sliceBuffer(bufferTail, 0, msgLength);
    if (isString) {
      try {
        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
      } catch (e) {
        // iPhone Safari doesn't let you apply to typed arrays
        var typed = new Uint8Array(msg);
        msg = '';
        for (var i = 0; i < typed.length; i++) {
          msg += String.fromCharCode(typed[i]);
        }
      }
    }

    buffers.push(msg);
    bufferTail = sliceBuffer(bufferTail, msgLength);
  }

  var total = buffers.length;
  buffers.forEach(function(buffer, i) {
    callback(exports.decodePacket(buffer, binaryType, true), i, total);
  });
};


/***/ }),

/***/ 739:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userContent_vue__ = __webpack_require__(678);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_906d47c6_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userContent_vue__ = __webpack_require__(751);
function injectStyle (ssrContext) {
  __webpack_require__(749)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-906d47c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_906d47c6_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(750);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("4ed7ad86", content, true, {});

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".user--content[data-v-906d47c6]{-webkit-transition:.3s;transition:.3s;width:250px;max-width:100%;height:35px;background:#fff;border-radius:50px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.user--content .user--content__photo[data-v-906d47c6]{-webkit-transition:.3s;transition:.3s;width:50px;min-width:50px;height:50px;background:#ddd;border:2px solid #fff;border-radius:50%;overflow:hidden;cursor:pointer}.user--content .user--content__photo .user[data-v-906d47c6]{width:100%}.user--content .user--content__photo .icon_config[data-v-906d47c6]{display:none}.user--content .user--content__name[data-v-906d47c6]{-webkit-transition:.3s;transition:.3s;font-size:14px;color:#515151;font-weight:300;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;text-align:center}.user--content .user--content__config[data-v-906d47c6]{-webkit-transition:.3s;transition:.3s;width:50px;height:35px;background:#979797;border-radius:50px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}.user--content .user--content__config:hover .config[data-v-906d47c6]{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.user--content .user--content__config .config[data-v-906d47c6]{-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s;width:25px;max-width:90%}@media screen and (max-width:800px){.user--content[data-v-906d47c6]{margin-left:5px;width:40px}.user--content .user--content__config[data-v-906d47c6],.user--content .user--content__name[data-v-906d47c6]{display:none}.user--content .user--content__photo[data-v-906d47c6]{background:#73001c;width:40px;min-width:40px;max-width:40px;border-radius:10px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border:none}.user--content .user--content__photo .icon_config[data-v-906d47c6]{display:inline}.user--content .user--content__photo .icon_photo[data-v-906d47c6]{display:none}.user--content .user--content__photo .config[data-v-906d47c6]{width:25px;margin:5px}}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/header/userContent.vue"],"names":[],"mappings":"AACA,gCACE,uBAAyB,AACzB,eAAiB,AACjB,YAAa,AACb,eAAgB,AAChB,YAAa,AACb,gBAAiB,AACjB,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,sDACI,uBAAyB,AACzB,eAAiB,AACjB,WAAY,AACZ,eAAgB,AAChB,YAAa,AACb,gBAAiB,AACjB,sBAAuB,AACvB,kBAAmB,AACnB,gBAAiB,AACjB,cAAgB,CACnB,AACD,4DACM,UAAY,CACjB,AACD,mEACM,YAAc,CACnB,AACD,qDACI,uBAAyB,AACzB,eAAiB,AACjB,eAAgB,AAChB,cAAe,AACf,gBAAiB,AACjB,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,iBAAmB,CACtB,AACD,uDAEI,uBAAyB,AACzB,eAAiB,AACjB,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,cAAgB,CACnB,AACD,qEACM,gCAAiC,AACzB,uBAAyB,CACtC,AACD,+DACM,yCAA0C,AAC1C,iCAAkC,AAClC,yBAA0B,AAC1B,+CAAiD,AACjD,WAAY,AACZ,aAAe,CACpB,AACD,oCACA,gCACI,gBAAiB,AACjB,UAAY,CACf,AACD,4GAEM,YAAc,CACnB,AACD,sDACM,mBAAoB,AACpB,WAAY,AACZ,eAAgB,AAChB,eAAgB,AAChB,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,WAAa,CAClB,AACD,mEACQ,cAAgB,CACvB,AACD,kEACQ,YAAc,CACrB,AACD,8DACQ,WAAY,AACZ,UAAY,CACnB,CACA","file":"userContent.vue","sourcesContent":["\n.user--content[data-v-906d47c6] {\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  width: 250px;\n  max-width: 100%;\n  height: 35px;\n  background: #fff;\n  border-radius: 50px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.user--content .user--content__photo[data-v-906d47c6] {\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n    width: 50px;\n    min-width: 50px;\n    height: 50px;\n    background: #ddd;\n    border: 2px solid #fff;\n    border-radius: 50%;\n    overflow: hidden;\n    cursor: pointer;\n}\n.user--content .user--content__photo .user[data-v-906d47c6] {\n      width: 100%;\n}\n.user--content .user--content__photo .icon_config[data-v-906d47c6] {\n      display: none;\n}\n.user--content .user--content__name[data-v-906d47c6] {\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n    font-size: 14px;\n    color: #515151;\n    font-weight: 300;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    text-align: center;\n}\n.user--content .user--content__config[data-v-906d47c6] {\n    cursor: pointer;\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n    width: 50px;\n    height: 35px;\n    background: #979797;\n    border-radius: 50px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    cursor: pointer;\n}\n.user--content .user--content__config:hover .config[data-v-906d47c6] {\n      -webkit-transform: rotate(90deg);\n              transform: rotate(90deg);\n}\n.user--content .user--content__config .config[data-v-906d47c6] {\n      -webkit-transition: -webkit-transform .2s;\n      transition: -webkit-transform .2s;\n      transition: transform .2s;\n      transition: transform .2s, -webkit-transform .2s;\n      width: 25px;\n      max-width: 90%;\n}\n@media screen and (max-width: 800px) {\n.user--content[data-v-906d47c6] {\n    margin-left: 5px;\n    width: 40px;\n}\n.user--content .user--content__config[data-v-906d47c6],\n    .user--content .user--content__name[data-v-906d47c6] {\n      display: none;\n}\n.user--content .user--content__photo[data-v-906d47c6] {\n      background: #73001c;\n      width: 40px;\n      min-width: 40px;\n      max-width: 40px;\n      border-radius: 10px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      border: none;\n}\n.user--content .user--content__photo .icon_config[data-v-906d47c6] {\n        display: inline;\n}\n.user--content .user--content__photo .icon_photo[data-v-906d47c6] {\n        display: none;\n}\n.user--content .user--content__photo .config[data-v-906d47c6] {\n        width: 25px;\n        margin: 5px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 751:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"user--content"},[_c('div',{staticClass:"user--content__photo",on:{"click":function($event){return _vm.showMenu()}}},[_c('img',{staticClass:"icon_photo user",attrs:{"src":__webpack_require__(669),"alt":"Perfil"}}),_vm._v(" "),_c('img',{staticClass:"icon_config config",attrs:{"src":__webpack_require__(670),"alt":"Configuration"}})]),_vm._v(" "),_c('div',{staticClass:"user--content__name"},[_vm._v("\r\n      "+_vm._s(_vm.user.name)+"\r\n    ")]),_vm._v(" "),_c('div',{staticClass:"user--content__config",on:{"click":function($event){return _vm.showMenu()}}},[_c('img',{staticClass:"config",attrs:{"src":__webpack_require__(671),"alt":"Minds"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 768:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(769);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("119b19e8", content, true, {});

/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, "footer[data-v-31e9ed4e]{background-image:-webkit-gradient(linear,left top,left bottom,color-stop(60%,#c50737),to(#cd1f26));background-image:linear-gradient(-180deg,#c50737 60%,#cd1f26)}.footer[data-v-31e9ed4e]{width:980px;max-width:100%;margin:0 auto;min-height:150px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#ff9aa6;padding-top:20px;padding-bottom:20px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:14px}.footer a[data-v-31e9ed4e],.footer router-link[data-v-31e9ed4e]{color:#ff9aa6;font-weight:700;-webkit-transition:.1s;transition:.1s;font-size:14px}.footer a[data-v-31e9ed4e]:hover,.footer router-link[data-v-31e9ed4e]:hover{color:#fff}.footer .footer--link .footer--link-ul[data-v-31e9ed4e]{list-style:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.footer .footer--link .footer--link-ul li[data-v-31e9ed4e]{margin-right:10px;margin-top:3px;margin-bottom:3px}.footer .footer--rights[data-v-31e9ed4e]{text-align:right}@media screen and (max-width:980px){.footer--link[data-v-31e9ed4e]{margin-left:20px}.footer--rights[data-v-31e9ed4e]{margin-right:20px}}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/footer/index.vue"],"names":[],"mappings":"AACA,wBACE,mGAAyG,AACzG,6DAAiE,CAClE,AACD,yBACE,YAAa,AACb,eAAgB,AAChB,cAAe,AACf,iBAAkB,AAClB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,cAAe,AACf,iBAAkB,AAClB,oBAAqB,AACrB,8BAA+B,AACvB,sBAAuB,AAC/B,cAAgB,CACjB,AACD,gEAEI,cAAe,AACf,gBAAkB,AAClB,uBAAyB,AACzB,eAAiB,AACjB,cAAgB,CACnB,AACD,4EAEM,UAAY,CACjB,AACD,wDACI,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,eAAgB,AACpB,uBAAwB,AACpB,oBAAqB,AACjB,0BAA4B,CACvC,AACD,2DACM,kBAAmB,AACnB,eAAgB,AAChB,iBAAmB,CACxB,AACD,yCACI,gBAAkB,CACrB,AACD,oCACA,+BACI,gBAAkB,CACrB,AACD,iCACI,iBAAmB,CACtB,CACA","file":"index.vue","sourcesContent":["\nfooter[data-v-31e9ed4e] {\n  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(60%, #C50737), to(#CD1F26));\n  background-image: linear-gradient(-180deg, #C50737 60%, #CD1F26);\n}\n.footer[data-v-31e9ed4e] {\n  width: 980px;\n  max-width: 100%;\n  margin: 0 auto;\n  min-height: 150px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #FF9AA6;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-size: 14px;\n}\n.footer a[data-v-31e9ed4e],\n  .footer router-link[data-v-31e9ed4e] {\n    color: #FF9AA6;\n    font-weight: bold;\n    -webkit-transition: 0.1s;\n    transition: 0.1s;\n    font-size: 14px;\n}\n.footer a[data-v-31e9ed4e]:hover,\n    .footer router-link[data-v-31e9ed4e]:hover {\n      color: #fff;\n}\n.footer .footer--link .footer--link-ul[data-v-31e9ed4e] {\n    list-style: none;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n}\n.footer .footer--link .footer--link-ul li[data-v-31e9ed4e] {\n      margin-right: 10px;\n      margin-top: 3px;\n      margin-bottom: 3px;\n}\n.footer .footer--rights[data-v-31e9ed4e] {\n    text-align: right;\n}\n@media screen and (max-width: 980px) {\n.footer--link[data-v-31e9ed4e] {\n    margin-left: 20px;\n}\n.footer--rights[data-v-31e9ed4e] {\n    margin-right: 20px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 770:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"hidden"},[_c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer--link"},[_c('ul',{staticClass:"footer--link-ul animation-left"},[_c('li',[_c('router-link',{attrs:{"to":{ name: '' }}},[_vm._v("Sobre")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: '' }}},[_vm._v("Escolas")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: '' }}},[_vm._v("A Minds")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: '' }}},[_vm._v("Ajuda")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: '' }}},[_vm._v("Normas")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: '' }}},[_vm._v("Politica de privacidade")])],1)])]),_vm._v(" "),_c('div',{staticClass:"footer--rights animation-right"},[_vm._v("\r\n        © "+_vm._s(_vm.year)+" Minds, Inc. Todos os direitos reservados.\r\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 772:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(773), __esModule: true };

/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(774);
var $Object = __webpack_require__(9).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ 774:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(29);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(23), 'Object', { defineProperty: __webpack_require__(32).f });


/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(1001);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(84)))

/***/ }),

/***/ 776:
/***/ (function(module, exports) {

/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */

exports.encode = function (obj) {
  var str = '';

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (str.length) str += '&';
      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
  }

  return str;
};

/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */

exports.decode = function(qs){
  var qry = {};
  var pairs = qs.split('&');
  for (var i = 0, l = pairs.length; i < l; i++) {
    var pair = pairs[i].split('=');
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
};


/***/ }),

/***/ 777:
/***/ (function(module, exports) {


module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};

/***/ }),

/***/ 778:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(1021);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(84)))

/***/ }),

/***/ 803:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChatMessage__ = __webpack_require__(932);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chat-box',
  data: function data() {
    return {
      messageText: '',
      recording: false,
      sentByMe: false,
      recordStart: 0,
      recordEnd: 0,
      recordInterval: null
    };
  },

  props: {
    chat: {
      type: Array,
      required: true
    },
    person: {
      type: String,
      required: true
    },
    sendMessage: {
      type: Function,
      required: true
    },
    padding: {
      type: Boolean,
      default: false
    },
    hasStream: {
      type: Boolean,
      required: true
    },
    muted: {
      type: Boolean,
      default: false
    },
    startRecording: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    stopRecording: {
      type: Function,
      default: function _default() {}
    },
    cancelRecording: {
      type: Function,
      default: function _default() {}
    }
  },
  computed: {
    messages: function messages() {
      return this.chat.sort(function (a, b) {
        return a.created_at - b.created_at;
      }).map(function (m, index, array) {
        if (index == 0) return m;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, m, {
          hide_name: array[index - 1]._id == m._id
        });
      });
    },
    canRecord: function canRecord() {
      return this.hasStream && !this.messageText && this.muted;
    },
    recordTime: function recordTime() {
      var dateObj = new Date(this.recordEnd - this.recordStart);

      return this.formatNumber(dateObj.getUTCMinutes()) + ':' + this.formatNumber(dateObj.getUTCSeconds());
    }
  },
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__ChatMessage__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__ChatMessage__["a" /* default */]),
  methods: {
    send: function send() {
      var success = this.sendMessage(this.messageText);

      if (success) {
        this.sentByMe = true;
        this.messageText = '';
        this.$refs['message-area'].focus();
      }
    },
    handleEnter: function handleEnter(event) {
      if (!event.shiftKey) {
        this.send();
      }
    },
    record: function record() {
      var _this = this;

      this.recording = this.startRecording();

      if (this.recording) {
        this.recordEnd = Date.now();
        this.recordStart = Date.now();

        this.recordInterval = setInterval(function () {
          _this.recordEnd = Date.now();
        }, 1000);
      }
    },
    sendRecord: function sendRecord() {
      this.stopRecording((this.recordEnd - this.recordStart) / 1000);
      this.recording = false;

      clearInterval(this.recordInterval);
      this.recordInterval = null;
    },
    cancelRecord: function cancelRecord() {
      this.cancelRecording();
      this.recording = false;

      clearInterval(this.recordInterval);
      this.recordInterval = null;
    },
    formatNumber: function formatNumber(number) {
      if (number < 10) return '0' + number;

      return number;
    }
  },
  watch: {
    chat: function chat() {
      var messages = this.$refs['chat-messages'];

      if (messages) {
        var space = messages.scrollHeight - messages.offsetHeight * 1.25;

        if (space < messages.scrollTop || this.sentByMe) {
          messages.scrollTop = messages.scrollHeight;

          if (this.sentByMe) this.sentByMe = false;
        }
      }
    }
  },
  mounted: function mounted() {
    this.$refs['chat-messages'].scrollTop = this.$refs['chat-messages'].scrollHeight;
  },
  beforeDestroy: function beforeDestroy() {
    if (this.recordInterval) clearInterval(this.recordInterval);
  }
});

/***/ }),

/***/ 804:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chat-message',
  props: {
    myself: {
      type: String,
      required: true
    },
    message: {
      type: Object,
      required: true
    }
  }
});

/***/ }),

/***/ 805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'student-video-chat',
  props: {
    student: {
      type: Object,
      required: true
    },
    canMute: {
      type: Boolean,
      default: false
    },
    setMuted: {
      type: Function,
      default: function _default() {}
    }
  },
  methods: {
    setStream: function setStream(stream) {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['video-player'].srcObject = stream;
      });
    }
  }
});

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/notification.d8d435a.mp3";

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var debug = __webpack_require__(1003)('socket.io-parser');
var Emitter = __webpack_require__(717);
var binary = __webpack_require__(1006);
var isArray = __webpack_require__(918);
var isBuf = __webpack_require__(919);

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = 4;

/**
 * Packet types.
 *
 * @api public
 */

exports.types = [
  'CONNECT',
  'DISCONNECT',
  'EVENT',
  'ACK',
  'ERROR',
  'BINARY_EVENT',
  'BINARY_ACK'
];

/**
 * Packet type `connect`.
 *
 * @api public
 */

exports.CONNECT = 0;

/**
 * Packet type `disconnect`.
 *
 * @api public
 */

exports.DISCONNECT = 1;

/**
 * Packet type `event`.
 *
 * @api public
 */

exports.EVENT = 2;

/**
 * Packet type `ack`.
 *
 * @api public
 */

exports.ACK = 3;

/**
 * Packet type `error`.
 *
 * @api public
 */

exports.ERROR = 4;

/**
 * Packet type 'binary event'
 *
 * @api public
 */

exports.BINARY_EVENT = 5;

/**
 * Packet type `binary ack`. For acks with binary arguments.
 *
 * @api public
 */

exports.BINARY_ACK = 6;

/**
 * Encoder constructor.
 *
 * @api public
 */

exports.Encoder = Encoder;

/**
 * Decoder constructor.
 *
 * @api public
 */

exports.Decoder = Decoder;

/**
 * A socket.io Encoder instance
 *
 * @api public
 */

function Encoder() {}

var ERROR_PACKET = exports.ERROR + '"encode error"';

/**
 * Encode a packet as a single string if non-binary, or as a
 * buffer sequence, depending on packet type.
 *
 * @param {Object} obj - packet object
 * @param {Function} callback - function to handle encodings (likely engine.write)
 * @return Calls callback with Array of encodings
 * @api public
 */

Encoder.prototype.encode = function(obj, callback){
  debug('encoding packet %j', obj);

  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    encodeAsBinary(obj, callback);
  } else {
    var encoding = encodeAsString(obj);
    callback([encoding]);
  }
};

/**
 * Encode packet as string.
 *
 * @param {Object} packet
 * @return {String} encoded
 * @api private
 */

function encodeAsString(obj) {

  // first is type
  var str = '' + obj.type;

  // attachments if we have them
  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    str += obj.attachments + '-';
  }

  // if we have a namespace other than `/`
  // we append it followed by a comma `,`
  if (obj.nsp && '/' !== obj.nsp) {
    str += obj.nsp + ',';
  }

  // immediately followed by the id
  if (null != obj.id) {
    str += obj.id;
  }

  // json data
  if (null != obj.data) {
    var payload = tryStringify(obj.data);
    if (payload !== false) {
      str += payload;
    } else {
      return ERROR_PACKET;
    }
  }

  debug('encoded %j as %s', obj, str);
  return str;
}

function tryStringify(str) {
  try {
    return JSON.stringify(str);
  } catch(e){
    return false;
  }
}

/**
 * Encode packet as 'buffer sequence' by removing blobs, and
 * deconstructing packet into object with placeholders and
 * a list of buffers.
 *
 * @param {Object} packet
 * @return {Buffer} encoded
 * @api private
 */

function encodeAsBinary(obj, callback) {

  function writeEncoding(bloblessData) {
    var deconstruction = binary.deconstructPacket(bloblessData);
    var pack = encodeAsString(deconstruction.packet);
    var buffers = deconstruction.buffers;

    buffers.unshift(pack); // add packet info to beginning of data list
    callback(buffers); // write all the buffers
  }

  binary.removeBlobs(obj, writeEncoding);
}

/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 * @api public
 */

function Decoder() {
  this.reconstructor = null;
}

/**
 * Mix in `Emitter` with Decoder.
 */

Emitter(Decoder.prototype);

/**
 * Decodes an encoded packet string into packet JSON.
 *
 * @param {String} obj - encoded packet
 * @return {Object} packet
 * @api public
 */

Decoder.prototype.add = function(obj) {
  var packet;
  if (typeof obj === 'string') {
    packet = decodeString(obj);
    if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) { // binary packet's json
      this.reconstructor = new BinaryReconstructor(packet);

      // no attachments, labeled binary but no binary data to follow
      if (this.reconstructor.reconPack.attachments === 0) {
        this.emit('decoded', packet);
      }
    } else { // non-binary full packet
      this.emit('decoded', packet);
    }
  } else if (isBuf(obj) || obj.base64) { // raw binary data
    if (!this.reconstructor) {
      throw new Error('got binary data when not reconstructing a packet');
    } else {
      packet = this.reconstructor.takeBinaryData(obj);
      if (packet) { // received final buffer
        this.reconstructor = null;
        this.emit('decoded', packet);
      }
    }
  } else {
    throw new Error('Unknown type: ' + obj);
  }
};

/**
 * Decode a packet String (JSON data)
 *
 * @param {String} str
 * @return {Object} packet
 * @api private
 */

function decodeString(str) {
  var i = 0;
  // look up type
  var p = {
    type: Number(str.charAt(0))
  };

  if (null == exports.types[p.type]) {
    return error('unknown packet type ' + p.type);
  }

  // look up attachments if type binary
  if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
    var start = i + 1;
    while (str.charAt(++i) !== '-' && i != str.length) {}
    var buf = str.substring(start, i);
    if (buf != Number(buf) || str.charAt(i) !== '-') {
      throw new Error('Illegal attachments');
    }
    p.attachments = Number(buf);
  }

  // look up namespace (if any)
  if ('/' === str.charAt(i + 1)) {
    var start = i + 1;
    while (++i) {
      var c = str.charAt(i);
      if (',' === c) break;
      if (i === str.length) break;
    }
    p.nsp = str.substring(start, i);
  } else {
    p.nsp = '/';
  }

  // look up id
  var next = str.charAt(i + 1);
  if ('' !== next && Number(next) == next) {
    var start = i + 1;
    while (++i) {
      var c = str.charAt(i);
      if (null == c || Number(c) != c) {
        --i;
        break;
      }
      if (i === str.length) break;
    }
    p.id = Number(str.substring(start, i + 1));
  }

  // look up json data
  if (str.charAt(++i)) {
    var payload = tryParse(str.substr(i));
    var isPayloadValid = payload !== false && (p.type === exports.ERROR || isArray(payload));
    if (isPayloadValid) {
      p.data = payload;
    } else {
      return error('invalid payload');
    }
  }

  debug('decoded %s as %j', str, p);
  return p;
}

function tryParse(str) {
  try {
    return JSON.parse(str);
  } catch(e){
    return false;
  }
}

/**
 * Deallocates a parser's resources
 *
 * @api public
 */

Decoder.prototype.destroy = function() {
  if (this.reconstructor) {
    this.reconstructor.finishedReconstruction();
  }
};

/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 * @api private
 */

function BinaryReconstructor(packet) {
  this.reconPack = packet;
  this.buffers = [];
}

/**
 * Method to be called when binary data received from connection
 * after a BINARY_EVENT packet.
 *
 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
 * @return {null | Object} returns null if more binary data is expected or
 *   a reconstructed packet object if all buffers have been received.
 * @api private
 */

BinaryReconstructor.prototype.takeBinaryData = function(binData) {
  this.buffers.push(binData);
  if (this.buffers.length === this.reconPack.attachments) { // done with buffer list
    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
    this.finishedReconstruction();
    return packet;
  }
  return null;
};

/**
 * Cleans up binary packet reconstruction variables.
 *
 * @api private
 */

BinaryReconstructor.prototype.finishedReconstruction = function() {
  this.reconPack = null;
  this.buffers = [];
};

function error(msg) {
  return {
    type: exports.ERROR,
    data: 'parser error: ' + msg
  };
}


/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1007)
var ieee754 = __webpack_require__(1008)
var isArray = __webpack_require__(1009)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

// browser shim for xmlhttprequest module

var hasCORS = __webpack_require__(1012);
var globalThis = __webpack_require__(875);

module.exports = function (opts) {
  var xdomain = opts.xdomain;

  // scheme must be same when usign XDomainRequest
  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
  var xscheme = opts.xscheme;

  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
  // https://github.com/Automattic/engine.io-client/pull/217
  var enablesXDR = opts.enablesXDR;

  // XMLHttpRequest can be disabled on IE
  try {
    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) { }

  // Use XDomainRequest for IE8 if enablesXDR is true
  // because loading bar keeps flashing when using jsonp-polling
  // https://github.com/yujiosaka/socke.io-ie8-loading-example
  try {
    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e) { }

  if (!xdomain) {
    try {
      return new globalThis[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
    } catch (e) { }
  }
};


/***/ }),

/***/ 875:
/***/ (function(module, exports) {

module.exports = (function () {
  if (typeof self !== 'undefined') {
    return self;
  } else if (typeof window !== 'undefined') {
    return window;
  } else {
    return Function('return this')(); // eslint-disable-line no-new-func
  }
})();


/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var parser = __webpack_require__(718);
var Emitter = __webpack_require__(717);

/**
 * Module exports.
 */

module.exports = Transport;

/**
 * Transport abstract constructor.
 *
 * @param {Object} options.
 * @api private
 */

function Transport (opts) {
  this.path = opts.path;
  this.hostname = opts.hostname;
  this.port = opts.port;
  this.secure = opts.secure;
  this.query = opts.query;
  this.timestampParam = opts.timestampParam;
  this.timestampRequests = opts.timestampRequests;
  this.readyState = '';
  this.agent = opts.agent || false;
  this.socket = opts.socket;
  this.enablesXDR = opts.enablesXDR;
  this.withCredentials = opts.withCredentials;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.forceNode = opts.forceNode;

  // results of ReactNative environment detection
  this.isReactNative = opts.isReactNative;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;
  this.localAddress = opts.localAddress;
}

/**
 * Mix in `Emitter`.
 */

Emitter(Transport.prototype);

/**
 * Emits an error.
 *
 * @param {String} str
 * @return {Transport} for chaining
 * @api public
 */

Transport.prototype.onError = function (msg, desc) {
  var err = new Error(msg);
  err.type = 'TransportError';
  err.description = desc;
  this.emit('error', err);
  return this;
};

/**
 * Opens the transport.
 *
 * @api public
 */

Transport.prototype.open = function () {
  if ('closed' === this.readyState || '' === this.readyState) {
    this.readyState = 'opening';
    this.doOpen();
  }

  return this;
};

/**
 * Closes the transport.
 *
 * @api private
 */

Transport.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.doClose();
    this.onClose();
  }

  return this;
};

/**
 * Sends multiple packets.
 *
 * @param {Array} packets
 * @api private
 */

Transport.prototype.send = function (packets) {
  if ('open' === this.readyState) {
    this.write(packets);
  } else {
    throw new Error('Transport not open');
  }
};

/**
 * Called upon open
 *
 * @api private
 */

Transport.prototype.onOpen = function () {
  this.readyState = 'open';
  this.writable = true;
  this.emit('open');
};

/**
 * Called with data.
 *
 * @param {String} data
 * @api private
 */

Transport.prototype.onData = function (data) {
  var packet = parser.decodePacket(data, this.socket.binaryType);
  this.onPacket(packet);
};

/**
 * Called with a decoded packet.
 */

Transport.prototype.onPacket = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon close.
 *
 * @api private
 */

Transport.prototype.onClose = function () {
  this.readyState = 'closed';
  this.emit('close');
};


/***/ }),

/***/ 885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__userContent__ = __webpack_require__(739);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'teacherHeader',
  components: {
    userContent: __WEBPACK_IMPORTED_MODULE_0__userContent__["a" /* default */]
  },
  computed: {
    teacher: function teacher() {
      return this.$store.getters['teacher/get'];
    }
  }
});

/***/ }),

/***/ 917:
/***/ (function(module, exports) {

/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */

var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

var parts = [
    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
];

module.exports = function parseuri(str) {
    var src = str,
        b = str.indexOf('['),
        e = str.indexOf(']');

    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }

    var m = re.exec(str || ''),
        uri = {},
        i = 14;

    while (i--) {
        uri[parts[i]] = m[i] || '';
    }

    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }

    uri.pathNames = pathNames(uri, uri['path']);
    uri.queryKey = queryKey(uri, uri['query']);

    return uri;
};

function pathNames(obj, path) {
    var regx = /\/{2,9}/g,
        names = path.replace(regx, "/").split("/");

    if (path.substr(0, 1) == '/' || path.length === 0) {
        names.splice(0, 1);
    }
    if (path.substr(path.length - 1, 1) == '/') {
        names.splice(names.length - 1, 1);
    }

    return names;
}

function queryKey(uri, query) {
    var data = {};

    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function ($0, $1, $2) {
        if ($1) {
            data[$1] = $2;
        }
    });

    return data;
}


/***/ }),

/***/ 918:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 919:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {
module.exports = isBuf;

var withNativeBuffer = typeof Buffer === 'function' && typeof Buffer.isBuffer === 'function';
var withNativeArrayBuffer = typeof ArrayBuffer === 'function';

var isView = function (obj) {
  return typeof ArrayBuffer.isView === 'function' ? ArrayBuffer.isView(obj) : (obj.buffer instanceof ArrayBuffer);
};

/**
 * Returns true if obj is a buffer or an arraybuffer.
 *
 * @api private
 */

function isBuf(obj) {
  return (withNativeBuffer && Buffer.isBuffer(obj)) ||
          (withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)));
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(873).Buffer))

/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var eio = __webpack_require__(1010);
var Socket = __webpack_require__(926);
var Emitter = __webpack_require__(717);
var parser = __webpack_require__(872);
var on = __webpack_require__(927);
var bind = __webpack_require__(928);
var debug = __webpack_require__(775)('socket.io-client:manager');
var indexOf = __webpack_require__(925);
var Backoff = __webpack_require__(1027);

/**
 * IE6+ hasOwnProperty
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Module exports
 */

module.exports = Manager;

/**
 * `Manager` constructor.
 *
 * @param {String} engine instance or engine uri/opts
 * @param {Object} options
 * @api public
 */

function Manager (uri, opts) {
  if (!(this instanceof Manager)) return new Manager(uri, opts);
  if (uri && ('object' === typeof uri)) {
    opts = uri;
    uri = undefined;
  }
  opts = opts || {};

  opts.path = opts.path || '/socket.io';
  this.nsps = {};
  this.subs = [];
  this.opts = opts;
  this.reconnection(opts.reconnection !== false);
  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnectionDelay(opts.reconnectionDelay || 1000);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
  this.randomizationFactor(opts.randomizationFactor || 0.5);
  this.backoff = new Backoff({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });
  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
  this.readyState = 'closed';
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;
  this.encoding = false;
  this.packetBuffer = [];
  var _parser = opts.parser || parser;
  this.encoder = new _parser.Encoder();
  this.decoder = new _parser.Decoder();
  this.autoConnect = opts.autoConnect !== false;
  if (this.autoConnect) this.open();
}

/**
 * Propagate given event to sockets and emit on `this`
 *
 * @api private
 */

Manager.prototype.emitAll = function () {
  this.emit.apply(this, arguments);
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
    }
  }
};

/**
 * Update `socket.id` of all sockets
 *
 * @api private
 */

Manager.prototype.updateSocketIds = function () {
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].id = this.generateId(nsp);
    }
  }
};

/**
 * generate `socket.id` for the given `nsp`
 *
 * @param {String} nsp
 * @return {String}
 * @api private
 */

Manager.prototype.generateId = function (nsp) {
  return (nsp === '/' ? '' : (nsp + '#')) + this.engine.id;
};

/**
 * Mix in `Emitter`.
 */

Emitter(Manager.prototype);

/**
 * Sets the `reconnection` config.
 *
 * @param {Boolean} true/false if it should automatically reconnect
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnection = function (v) {
  if (!arguments.length) return this._reconnection;
  this._reconnection = !!v;
  return this;
};

/**
 * Sets the reconnection attempts config.
 *
 * @param {Number} max reconnection attempts before giving up
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionAttempts = function (v) {
  if (!arguments.length) return this._reconnectionAttempts;
  this._reconnectionAttempts = v;
  return this;
};

/**
 * Sets the delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelay = function (v) {
  if (!arguments.length) return this._reconnectionDelay;
  this._reconnectionDelay = v;
  this.backoff && this.backoff.setMin(v);
  return this;
};

Manager.prototype.randomizationFactor = function (v) {
  if (!arguments.length) return this._randomizationFactor;
  this._randomizationFactor = v;
  this.backoff && this.backoff.setJitter(v);
  return this;
};

/**
 * Sets the maximum delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelayMax = function (v) {
  if (!arguments.length) return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v;
  this.backoff && this.backoff.setMax(v);
  return this;
};

/**
 * Sets the connection timeout. `false` to disable
 *
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.timeout = function (v) {
  if (!arguments.length) return this._timeout;
  this._timeout = v;
  return this;
};

/**
 * Starts trying to reconnect if reconnection is enabled and we have not
 * started reconnecting yet
 *
 * @api private
 */

Manager.prototype.maybeReconnectOnOpen = function () {
  // Only try to reconnect if it's the first time we're connecting
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    // keeps reconnection from firing twice for the same reconnection loop
    this.reconnect();
  }
};

/**
 * Sets the current transport `socket`.
 *
 * @param {Function} optional, callback
 * @return {Manager} self
 * @api public
 */

Manager.prototype.open =
Manager.prototype.connect = function (fn, opts) {
  debug('readyState %s', this.readyState);
  if (~this.readyState.indexOf('open')) return this;

  debug('opening %s', this.uri);
  this.engine = eio(this.uri, this.opts);
  var socket = this.engine;
  var self = this;
  this.readyState = 'opening';
  this.skipReconnect = false;

  // emit `open`
  var openSub = on(socket, 'open', function () {
    self.onopen();
    fn && fn();
  });

  // emit `connect_error`
  var errorSub = on(socket, 'error', function (data) {
    debug('connect_error');
    self.cleanup();
    self.readyState = 'closed';
    self.emitAll('connect_error', data);
    if (fn) {
      var err = new Error('Connection error');
      err.data = data;
      fn(err);
    } else {
      // Only do this if there is no fn to handle the error
      self.maybeReconnectOnOpen();
    }
  });

  // emit `connect_timeout`
  if (false !== this._timeout) {
    var timeout = this._timeout;
    debug('connect attempt will timeout after %d', timeout);

    if (timeout === 0) {
      openSub.destroy(); // prevents a race condition with the 'open' event
    }

    // set timer
    var timer = setTimeout(function () {
      debug('connect attempt timed out after %d', timeout);
      openSub.destroy();
      socket.close();
      socket.emit('error', 'timeout');
      self.emitAll('connect_timeout', timeout);
    }, timeout);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }

  this.subs.push(openSub);
  this.subs.push(errorSub);

  return this;
};

/**
 * Called upon transport open.
 *
 * @api private
 */

Manager.prototype.onopen = function () {
  debug('open');

  // clear old subs
  this.cleanup();

  // mark as open
  this.readyState = 'open';
  this.emit('open');

  // add new subs
  var socket = this.engine;
  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
};

/**
 * Called upon a ping.
 *
 * @api private
 */

Manager.prototype.onping = function () {
  this.lastPing = new Date();
  this.emitAll('ping');
};

/**
 * Called upon a packet.
 *
 * @api private
 */

Manager.prototype.onpong = function () {
  this.emitAll('pong', new Date() - this.lastPing);
};

/**
 * Called with data.
 *
 * @api private
 */

Manager.prototype.ondata = function (data) {
  this.decoder.add(data);
};

/**
 * Called when parser fully decodes a packet.
 *
 * @api private
 */

Manager.prototype.ondecoded = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon socket error.
 *
 * @api private
 */

Manager.prototype.onerror = function (err) {
  debug('error', err);
  this.emitAll('error', err);
};

/**
 * Creates a new socket for the given `nsp`.
 *
 * @return {Socket}
 * @api public
 */

Manager.prototype.socket = function (nsp, opts) {
  var socket = this.nsps[nsp];
  if (!socket) {
    socket = new Socket(this, nsp, opts);
    this.nsps[nsp] = socket;
    var self = this;
    socket.on('connecting', onConnecting);
    socket.on('connect', function () {
      socket.id = self.generateId(nsp);
    });

    if (this.autoConnect) {
      // manually call here since connecting event is fired before listening
      onConnecting();
    }
  }

  function onConnecting () {
    if (!~indexOf(self.connecting, socket)) {
      self.connecting.push(socket);
    }
  }

  return socket;
};

/**
 * Called upon a socket close.
 *
 * @param {Socket} socket
 */

Manager.prototype.destroy = function (socket) {
  var index = indexOf(this.connecting, socket);
  if (~index) this.connecting.splice(index, 1);
  if (this.connecting.length) return;

  this.close();
};

/**
 * Writes a packet.
 *
 * @param {Object} packet
 * @api private
 */

Manager.prototype.packet = function (packet) {
  debug('writing packet %j', packet);
  var self = this;
  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;

  if (!self.encoding) {
    // encode, then write to engine with result
    self.encoding = true;
    this.encoder.encode(packet, function (encodedPackets) {
      for (var i = 0; i < encodedPackets.length; i++) {
        self.engine.write(encodedPackets[i], packet.options);
      }
      self.encoding = false;
      self.processPacketQueue();
    });
  } else { // add packet to the queue
    self.packetBuffer.push(packet);
  }
};

/**
 * If packet buffer is non-empty, begins encoding the
 * next packet in line.
 *
 * @api private
 */

Manager.prototype.processPacketQueue = function () {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var pack = this.packetBuffer.shift();
    this.packet(pack);
  }
};

/**
 * Clean up transport subscriptions and packet buffer.
 *
 * @api private
 */

Manager.prototype.cleanup = function () {
  debug('cleanup');

  var subsLength = this.subs.length;
  for (var i = 0; i < subsLength; i++) {
    var sub = this.subs.shift();
    sub.destroy();
  }

  this.packetBuffer = [];
  this.encoding = false;
  this.lastPing = null;

  this.decoder.destroy();
};

/**
 * Close the current socket.
 *
 * @api private
 */

Manager.prototype.close =
Manager.prototype.disconnect = function () {
  debug('disconnect');
  this.skipReconnect = true;
  this.reconnecting = false;
  if ('opening' === this.readyState) {
    // `onclose` will not fire because
    // an open event never happened
    this.cleanup();
  }
  this.backoff.reset();
  this.readyState = 'closed';
  if (this.engine) this.engine.close();
};

/**
 * Called upon engine close.
 *
 * @api private
 */

Manager.prototype.onclose = function (reason) {
  debug('onclose');

  this.cleanup();
  this.backoff.reset();
  this.readyState = 'closed';
  this.emit('close', reason);

  if (this._reconnection && !this.skipReconnect) {
    this.reconnect();
  }
};

/**
 * Attempt a reconnection.
 *
 * @api private
 */

Manager.prototype.reconnect = function () {
  if (this.reconnecting || this.skipReconnect) return this;

  var self = this;

  if (this.backoff.attempts >= this._reconnectionAttempts) {
    debug('reconnect failed');
    this.backoff.reset();
    this.emitAll('reconnect_failed');
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    debug('will wait %dms before reconnect attempt', delay);

    this.reconnecting = true;
    var timer = setTimeout(function () {
      if (self.skipReconnect) return;

      debug('attempting reconnect');
      self.emitAll('reconnect_attempt', self.backoff.attempts);
      self.emitAll('reconnecting', self.backoff.attempts);

      // check again for the case socket closed in above events
      if (self.skipReconnect) return;

      self.open(function (err) {
        if (err) {
          debug('reconnect attempt error');
          self.reconnecting = false;
          self.reconnect();
          self.emitAll('reconnect_error', err.data);
        } else {
          debug('reconnect success');
          self.onreconnect();
        }
      });
    }, delay);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }
};

/**
 * Called upon successful reconnect.
 *
 * @api private
 */

Manager.prototype.onreconnect = function () {
  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.updateSocketIds();
  this.emitAll('reconnect', attempt);
};


/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var XMLHttpRequest = __webpack_require__(874);
var XHR = __webpack_require__(1013);
var JSONP = __webpack_require__(1023);
var websocket = __webpack_require__(1024);

/**
 * Export transports.
 */

exports.polling = polling;
exports.websocket = websocket;

/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */

function polling (opts) {
  var xhr;
  var xd = false;
  var xs = false;
  var jsonp = false !== opts.jsonp;

  if (typeof location !== 'undefined') {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    xd = opts.hostname !== location.hostname || port !== opts.port;
    xs = opts.secure !== isSSL;
  }

  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr = new XMLHttpRequest(opts);

  if ('open' in xhr && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp) throw new Error('JSONP disabled');
    return new JSONP(opts);
  }
}


/***/ }),

/***/ 922:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Transport = __webpack_require__(876);
var parseqs = __webpack_require__(776);
var parser = __webpack_require__(718);
var inherit = __webpack_require__(777);
var yeast = __webpack_require__(924);
var debug = __webpack_require__(778)('engine.io-client:polling');

/**
 * Module exports.
 */

module.exports = Polling;

/**
 * Is XHR2 supported?
 */

var hasXHR2 = (function () {
  var XMLHttpRequest = __webpack_require__(874);
  var xhr = new XMLHttpRequest({ xdomain: false });
  return null != xhr.responseType;
})();

/**
 * Polling interface.
 *
 * @param {Object} opts
 * @api private
 */

function Polling (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (!hasXHR2 || forceBase64) {
    this.supportsBinary = false;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(Polling, Transport);

/**
 * Transport name.
 */

Polling.prototype.name = 'polling';

/**
 * Opens the socket (triggers polling). We write a PING message to determine
 * when the transport is open.
 *
 * @api private
 */

Polling.prototype.doOpen = function () {
  this.poll();
};

/**
 * Pauses polling.
 *
 * @param {Function} callback upon buffers are flushed and transport is paused
 * @api private
 */

Polling.prototype.pause = function (onPause) {
  var self = this;

  this.readyState = 'pausing';

  function pause () {
    debug('paused');
    self.readyState = 'paused';
    onPause();
  }

  if (this.polling || !this.writable) {
    var total = 0;

    if (this.polling) {
      debug('we are currently polling - waiting to pause');
      total++;
      this.once('pollComplete', function () {
        debug('pre-pause polling complete');
        --total || pause();
      });
    }

    if (!this.writable) {
      debug('we are currently writing - waiting to pause');
      total++;
      this.once('drain', function () {
        debug('pre-pause writing complete');
        --total || pause();
      });
    }
  } else {
    pause();
  }
};

/**
 * Starts polling cycle.
 *
 * @api public
 */

Polling.prototype.poll = function () {
  debug('polling');
  this.polling = true;
  this.doPoll();
  this.emit('poll');
};

/**
 * Overloads onData to detect payloads.
 *
 * @api private
 */

Polling.prototype.onData = function (data) {
  var self = this;
  debug('polling got data %s', data);
  var callback = function (packet, index, total) {
    // if its the first message we consider the transport open
    if ('opening' === self.readyState && packet.type === 'open') {
      self.onOpen();
    }

    // if its a close packet, we close the ongoing requests
    if ('close' === packet.type) {
      self.onClose();
      return false;
    }

    // otherwise bypass onData and handle the message
    self.onPacket(packet);
  };

  // decode payload
  parser.decodePayload(data, this.socket.binaryType, callback);

  // if an event did not trigger closing
  if ('closed' !== this.readyState) {
    // if we got data we're not polling
    this.polling = false;
    this.emit('pollComplete');

    if ('open' === this.readyState) {
      this.poll();
    } else {
      debug('ignoring poll - transport state "%s"', this.readyState);
    }
  }
};

/**
 * For polling, send a close packet.
 *
 * @api private
 */

Polling.prototype.doClose = function () {
  var self = this;

  function close () {
    debug('writing close packet');
    self.write([{ type: 'close' }]);
  }

  if ('open' === this.readyState) {
    debug('transport open - closing');
    close();
  } else {
    // in case we're trying to close while
    // handshaking is in progress (GH-164)
    debug('transport not open - deferring close');
    this.once('open', close);
  }
};

/**
 * Writes a packets payload.
 *
 * @param {Array} data packets
 * @param {Function} drain callback
 * @api private
 */

Polling.prototype.write = function (packets) {
  var self = this;
  this.writable = false;
  var callbackfn = function () {
    self.writable = true;
    self.emit('drain');
  };

  parser.encodePayload(packets, this.supportsBinary, function (data) {
    self.doWrite(data, callbackfn);
  });
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

Polling.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'https' : 'http';
  var port = '';

  // cache busting is forced
  if (false !== this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  if (!this.supportsBinary && !query.sid) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // avoid port if default for schema
  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
     ('http' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};


/***/ }),

/***/ 923:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/* global Blob File */

/*
 * Module requirements.
 */

var isArray = __webpack_require__(1015);

var toString = Object.prototype.toString;
var withNativeBlob = typeof Blob === 'function' ||
                        typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]';
var withNativeFile = typeof File === 'function' ||
                        typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]';

/**
 * Module exports.
 */

module.exports = hasBinary;

/**
 * Checks for binary data.
 *
 * Supports Buffer, ArrayBuffer, Blob and File.
 *
 * @param {Object} anything
 * @api public
 */

function hasBinary (obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      if (hasBinary(obj[i])) {
        return true;
      }
    }
    return false;
  }

  if ((typeof Buffer === 'function' && Buffer.isBuffer && Buffer.isBuffer(obj)) ||
    (typeof ArrayBuffer === 'function' && obj instanceof ArrayBuffer) ||
    (withNativeBlob && obj instanceof Blob) ||
    (withNativeFile && obj instanceof File)
  ) {
    return true;
  }

  // see: https://github.com/Automattic/has-binary/pull/4
  if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) {
    return hasBinary(obj.toJSON(), true);
  }

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
      return true;
    }
  }

  return false;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(873).Buffer))

/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
  , length = 64
  , map = {}
  , seed = 0
  , i = 0
  , prev;

/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}

/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}

/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
  var now = encode(+new Date());

  if (now !== prev) return seed = 0, prev = now;
  return now +'.'+ encode(seed++);
}

//
// Map each character to its index.
//
for (; i < length; i++) map[alphabet[i]] = i;

//
// Expose the `yeast`, `encode` and `decode` functions.
//
yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;


/***/ }),

/***/ 925:
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parser = __webpack_require__(872);
var Emitter = __webpack_require__(717);
var toArray = __webpack_require__(1026);
var on = __webpack_require__(927);
var bind = __webpack_require__(928);
var debug = __webpack_require__(775)('socket.io-client:socket');
var parseqs = __webpack_require__(776);
var hasBin = __webpack_require__(923);

/**
 * Module exports.
 */

module.exports = exports = Socket;

/**
 * Internal events (blacklisted).
 * These events can't be emitted by the user.
 *
 * @api private
 */

var events = {
  connect: 1,
  connect_error: 1,
  connect_timeout: 1,
  connecting: 1,
  disconnect: 1,
  error: 1,
  reconnect: 1,
  reconnect_attempt: 1,
  reconnect_failed: 1,
  reconnect_error: 1,
  reconnecting: 1,
  ping: 1,
  pong: 1
};

/**
 * Shortcut to `Emitter#emit`.
 */

var emit = Emitter.prototype.emit;

/**
 * `Socket` constructor.
 *
 * @api public
 */

function Socket (io, nsp, opts) {
  this.io = io;
  this.nsp = nsp;
  this.json = this; // compat
  this.ids = 0;
  this.acks = {};
  this.receiveBuffer = [];
  this.sendBuffer = [];
  this.connected = false;
  this.disconnected = true;
  this.flags = {};
  if (opts && opts.query) {
    this.query = opts.query;
  }
  if (this.io.autoConnect) this.open();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Subscribe to open, close and packet events
 *
 * @api private
 */

Socket.prototype.subEvents = function () {
  if (this.subs) return;

  var io = this.io;
  this.subs = [
    on(io, 'open', bind(this, 'onopen')),
    on(io, 'packet', bind(this, 'onpacket')),
    on(io, 'close', bind(this, 'onclose'))
  ];
};

/**
 * "Opens" the socket.
 *
 * @api public
 */

Socket.prototype.open =
Socket.prototype.connect = function () {
  if (this.connected) return this;

  this.subEvents();
  if (!this.io.reconnecting) this.io.open(); // ensure open
  if ('open' === this.io.readyState) this.onopen();
  this.emit('connecting');
  return this;
};

/**
 * Sends a `message` event.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.send = function () {
  var args = toArray(arguments);
  args.unshift('message');
  this.emit.apply(this, args);
  return this;
};

/**
 * Override `emit`.
 * If the event is in `events`, it's emitted normally.
 *
 * @param {String} event name
 * @return {Socket} self
 * @api public
 */

Socket.prototype.emit = function (ev) {
  if (events.hasOwnProperty(ev)) {
    emit.apply(this, arguments);
    return this;
  }

  var args = toArray(arguments);
  var packet = {
    type: (this.flags.binary !== undefined ? this.flags.binary : hasBin(args)) ? parser.BINARY_EVENT : parser.EVENT,
    data: args
  };

  packet.options = {};
  packet.options.compress = !this.flags || false !== this.flags.compress;

  // event ack callback
  if ('function' === typeof args[args.length - 1]) {
    debug('emitting packet with ack id %d', this.ids);
    this.acks[this.ids] = args.pop();
    packet.id = this.ids++;
  }

  if (this.connected) {
    this.packet(packet);
  } else {
    this.sendBuffer.push(packet);
  }

  this.flags = {};

  return this;
};

/**
 * Sends a packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.packet = function (packet) {
  packet.nsp = this.nsp;
  this.io.packet(packet);
};

/**
 * Called upon engine `open`.
 *
 * @api private
 */

Socket.prototype.onopen = function () {
  debug('transport is open - connecting');

  // write connect packet if necessary
  if ('/' !== this.nsp) {
    if (this.query) {
      var query = typeof this.query === 'object' ? parseqs.encode(this.query) : this.query;
      debug('sending connect packet with query %s', query);
      this.packet({type: parser.CONNECT, query: query});
    } else {
      this.packet({type: parser.CONNECT});
    }
  }
};

/**
 * Called upon engine `close`.
 *
 * @param {String} reason
 * @api private
 */

Socket.prototype.onclose = function (reason) {
  debug('close (%s)', reason);
  this.connected = false;
  this.disconnected = true;
  delete this.id;
  this.emit('disconnect', reason);
};

/**
 * Called with socket packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onpacket = function (packet) {
  var sameNamespace = packet.nsp === this.nsp;
  var rootNamespaceError = packet.type === parser.ERROR && packet.nsp === '/';

  if (!sameNamespace && !rootNamespaceError) return;

  switch (packet.type) {
    case parser.CONNECT:
      this.onconnect();
      break;

    case parser.EVENT:
      this.onevent(packet);
      break;

    case parser.BINARY_EVENT:
      this.onevent(packet);
      break;

    case parser.ACK:
      this.onack(packet);
      break;

    case parser.BINARY_ACK:
      this.onack(packet);
      break;

    case parser.DISCONNECT:
      this.ondisconnect();
      break;

    case parser.ERROR:
      this.emit('error', packet.data);
      break;
  }
};

/**
 * Called upon a server event.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onevent = function (packet) {
  var args = packet.data || [];
  debug('emitting event %j', args);

  if (null != packet.id) {
    debug('attaching ack callback to event');
    args.push(this.ack(packet.id));
  }

  if (this.connected) {
    emit.apply(this, args);
  } else {
    this.receiveBuffer.push(args);
  }
};

/**
 * Produces an ack callback to emit with an event.
 *
 * @api private
 */

Socket.prototype.ack = function (id) {
  var self = this;
  var sent = false;
  return function () {
    // prevent double callbacks
    if (sent) return;
    sent = true;
    var args = toArray(arguments);
    debug('sending ack %j', args);

    self.packet({
      type: hasBin(args) ? parser.BINARY_ACK : parser.ACK,
      id: id,
      data: args
    });
  };
};

/**
 * Called upon a server acknowlegement.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onack = function (packet) {
  var ack = this.acks[packet.id];
  if ('function' === typeof ack) {
    debug('calling ack %s with %j', packet.id, packet.data);
    ack.apply(this, packet.data);
    delete this.acks[packet.id];
  } else {
    debug('bad ack %s', packet.id);
  }
};

/**
 * Called upon server connect.
 *
 * @api private
 */

Socket.prototype.onconnect = function () {
  this.connected = true;
  this.disconnected = false;
  this.emitBuffered();
  this.emit('connect');
};

/**
 * Emit buffered events (received and emitted).
 *
 * @api private
 */

Socket.prototype.emitBuffered = function () {
  var i;
  for (i = 0; i < this.receiveBuffer.length; i++) {
    emit.apply(this, this.receiveBuffer[i]);
  }
  this.receiveBuffer = [];

  for (i = 0; i < this.sendBuffer.length; i++) {
    this.packet(this.sendBuffer[i]);
  }
  this.sendBuffer = [];
};

/**
 * Called upon server disconnect.
 *
 * @api private
 */

Socket.prototype.ondisconnect = function () {
  debug('server disconnect (%s)', this.nsp);
  this.destroy();
  this.onclose('io server disconnect');
};

/**
 * Called upon forced client/server side disconnections,
 * this method ensures the manager stops tracking us and
 * that reconnections don't get triggered for this.
 *
 * @api private.
 */

Socket.prototype.destroy = function () {
  if (this.subs) {
    // clean subscriptions to avoid reconnections
    for (var i = 0; i < this.subs.length; i++) {
      this.subs[i].destroy();
    }
    this.subs = null;
  }

  this.io.destroy(this);
};

/**
 * Disconnects the socket manually.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.close =
Socket.prototype.disconnect = function () {
  if (this.connected) {
    debug('performing disconnect (%s)', this.nsp);
    this.packet({ type: parser.DISCONNECT });
  }

  // remove socket from pool
  this.destroy();

  if (this.connected) {
    // fire events
    this.onclose('io client disconnect');
  }
  return this;
};

/**
 * Sets the compress flag.
 *
 * @param {Boolean} if `true`, compresses the sending data
 * @return {Socket} self
 * @api public
 */

Socket.prototype.compress = function (compress) {
  this.flags.compress = compress;
  return this;
};

/**
 * Sets the binary flag
 *
 * @param {Boolean} whether the emitted data contains binary
 * @return {Socket} self
 * @api public
 */

Socket.prototype.binary = function (binary) {
  this.flags.binary = binary;
  return this;
};


/***/ }),

/***/ 927:
/***/ (function(module, exports) {


/**
 * Module exports.
 */

module.exports = on;

/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */

function on (obj, ev, fn) {
  obj.on(ev, fn);
  return {
    destroy: function () {
      obj.removeListener(ev, fn);
    }
  };
}


/***/ }),

/***/ 928:
/***/ (function(module, exports) {

/**
 * Slice reference.
 */

var slice = [].slice;

/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */

module.exports = function(obj, fn){
  if ('string' == typeof fn) fn = obj[fn];
  if ('function' != typeof fn) throw new Error('bind() requires a function');
  var args = slice.call(arguments, 2);
  return function(){
    return fn.apply(obj, args.concat(slice.call(arguments)));
  }
};


/***/ }),

/***/ 929:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(803);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b3289f3_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(936);
function injectStyle (ssrContext) {
  __webpack_require__(930)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b3289f3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b3289f3_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(931);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("5b704b16", content, true, {});

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".chat[data-v-5b3289f3]{padding:0 10px 10px;-ms-flex-preferred-size:26vw;flex-basis:26vw;min-width:450px;max-height:100%}.chat.chat--padding[data-v-5b3289f3]{padding-top:77px}.chat__box[data-v-5b3289f3]{margin:0 15px;padding:10px;width:calc(100% - 35px);height:100%;background-color:#bbb;border-radius:10px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.chat__box__messages[data-v-5b3289f3]{max-height:100%;overflow-y:auto}.chat__box__form[data-v-5b3289f3]{padding:5px;padding-right:0;margin-top:5px}.chat__box__form textarea[data-v-5b3289f3]{font-family:Volte,sans-serif;resize:none;padding:10px;-webkit-box-flex:1;-ms-flex:1;flex:1}.chat__box__form button[data-v-5b3289f3]{margin-left:5px;width:40px;height:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0}.chat__box__form button svg[data-v-5b3289f3]{font-size:20px}.chat__box__form span[data-v-5b3289f3]{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center;margin:auto}.chat__box__form__cancel[data-v-5b3289f3]{margin-right:5px}@media screen and (max-width:800px){.chat[data-v-5b3289f3]{padding:0 10px;-ms-flex-preferred-size:26vw;flex-basis:26vw;min-width:100%;max-height:35vh}.chat__box[data-v-5b3289f3]{margin:0;width:100%}.chat.chat--padding[data-v-5b3289f3]{padding:0 10px}}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/ChatBox/index.vue"],"names":[],"mappings":"AACA,uBACE,oBAA0B,AAC1B,6BAA8B,AAC1B,gBAAiB,AACrB,gBAAiB,AACjB,eAAiB,CAClB,AACD,qCACI,gBAAkB,CACrB,AACD,4BACI,cAAe,AACf,aAAc,AACd,wBAAyB,AACzB,YAAa,AACb,sBAAuB,AACvB,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACrC,AACD,sCACM,gBAAiB,AACjB,eAAiB,CACtB,AACD,kCACM,YAAa,AACb,gBAAiB,AACjB,cAAgB,CACrB,AACD,2CACQ,6BAAiC,AACjC,YAAa,AACb,aAAc,AACd,mBAAoB,AAChB,WAAY,AACR,MAAQ,CACvB,AACD,yCACQ,gBAAiB,AACjB,WAAY,AACZ,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,SAAW,CAClB,AACD,6CACU,cAAgB,CACzB,AACD,uCACQ,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,kBAAmB,AACnB,WAAa,CACpB,AACD,0CACQ,gBAAkB,CACzB,AACD,oCACA,uBACI,eAAgB,AAChB,6BAA8B,AAC1B,gBAAiB,AACrB,eAAgB,AAChB,eAAiB,CACpB,AACD,4BACM,SAAU,AACV,UAAY,CACjB,AACD,qCACM,cAAgB,CACrB,CACA","file":"index.vue","sourcesContent":["\n.chat[data-v-5b3289f3] {\n  padding: 0 10px 10px 10px;\n  -ms-flex-preferred-size: 26vw;\n      flex-basis: 26vw;\n  min-width: 450px;\n  max-height: 100%;\n}\n.chat.chat--padding[data-v-5b3289f3] {\n    padding-top: 77px;\n}\n.chat__box[data-v-5b3289f3] {\n    margin: 0 15px;\n    padding: 10px;\n    width: calc(100% - 35px);\n    height: 100%;\n    background-color: #bbb;\n    border-radius: 10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n}\n.chat__box__messages[data-v-5b3289f3] {\n      max-height: 100%;\n      overflow-y: auto;\n}\n.chat__box__form[data-v-5b3289f3] {\n      padding: 5px;\n      padding-right: 0;\n      margin-top: 5px;\n}\n.chat__box__form textarea[data-v-5b3289f3] {\n        font-family: 'Volte', sans-serif;\n        resize: none;\n        padding: 10px;\n        -webkit-box-flex: 1;\n            -ms-flex: 1;\n                flex: 1;\n}\n.chat__box__form button[data-v-5b3289f3] {\n        margin-left: 5px;\n        width: 40px;\n        height: 40px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        padding: 0;\n}\n.chat__box__form button svg[data-v-5b3289f3] {\n          font-size: 20px;\n}\n.chat__box__form span[data-v-5b3289f3] {\n        -webkit-box-flex: 1;\n            -ms-flex: 1;\n                flex: 1;\n        text-align: center;\n        margin: auto;\n}\n.chat__box__form__cancel[data-v-5b3289f3] {\n        margin-right: 5px;\n}\n@media screen and (max-width: 800px) {\n.chat[data-v-5b3289f3] {\n    padding: 0 10px;\n    -ms-flex-preferred-size: 26vw;\n        flex-basis: 26vw;\n    min-width: 100%;\n    max-height: 35vh;\n}\n.chat__box[data-v-5b3289f3] {\n      margin: 0;\n      width: 100%;\n}\n.chat.chat--padding[data-v-5b3289f3] {\n      padding: 0 10px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 932:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatMessage_vue__ = __webpack_require__(804);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_347162d3_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatMessage_vue__ = __webpack_require__(935);
function injectStyle (ssrContext) {
  __webpack_require__(933)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-347162d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_347162d3_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(934);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("2c36f042", content, true, {});

/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".align-center[data-v-347162d3]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@-webkit-keyframes loadAudioPlayer-data-v-347162d3{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@keyframes loadAudioPlayer-data-v-347162d3{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@-webkit-keyframes loadAudioPlayerReset-data-v-347162d3{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}@keyframes loadAudioPlayerReset-data-v-347162d3{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}.animationLoadCircle[data-v-347162d3]{-webkit-animation-name:loadAudioPlayer-data-v-347162d3;animation-name:loadAudioPlayer-data-v-347162d3;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.animationLoadCircle.reset[data-v-347162d3]{animation-direction:reverse;-webkit-animation-duration:.5s;animation-duration:.5s}.chat-message[data-v-347162d3]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin:5px;background-color:#009bff;padding:6px 12px;-ms-flex-item-align:start;align-self:flex-start;border-radius:15px 15px 15px 0}.chat-message.self[data-v-347162d3]{-ms-flex-item-align:end;align-self:flex-end;border-radius:15px 15px 0 15px}.chat-message.no-margin-top[data-v-347162d3]{margin-top:0;border-radius:0 15px 15px 0}.chat-message.no-margin-top.self[data-v-347162d3]{border-radius:15px 0 0 15px}.chat-message span[data-v-347162d3]{color:#6200e5}.chat-message pre[data-v-347162d3]{font-family:Volte,sans-serif;color:#fff;white-space:pre-wrap;word-break:break-all}.chat-notification[data-v-347162d3]{padding:5px 0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.chat-notification.join[data-v-347162d3]{color:#6200e5}.chat-notification.leave[data-v-347162d3]{color:#6f6f6f}.chat-notification.attention[data-v-347162d3]{color:#c2003c;border-top:2px solid #c2003c;border-bottom:2px solid #c2003c}.chat-notification.disconnect[data-v-347162d3]{color:#c2003c}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/ChatBox/ChatMessage.vue"],"names":[],"mappings":"AACA,+BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,mDACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,2CACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,wDACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,gDACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,sCACE,uDAAwD,AAChD,+CAAgD,AACxD,qCAAsC,AAC9B,4BAA8B,CACvC,AACD,4CACI,4BAA6B,AAC7B,+BAAgC,AACxB,sBAAwB,CACnC,AACD,+BACE,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,WAAY,AACZ,yBAA0B,AAC1B,iBAAkB,AAClB,0BAA2B,AACvB,sBAAuB,AAC3B,8BAAgC,CACjC,AACD,oCACI,wBAAyB,AACrB,oBAAqB,AACzB,8BAAgC,CACnC,AACD,6CACI,aAAc,AACd,2BAA6B,CAChC,AACD,kDACI,2BAA6B,CAChC,AACD,oCACI,aAAe,CAClB,AACD,mCACI,6BAAiC,AACjC,WAAe,AACf,qBAAsB,AACtB,oBAAsB,CACzB,AACD,oCACE,cAAe,AACf,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,yCACI,aAAe,CAClB,AACD,0CACI,aAAe,CAClB,AACD,8CACI,cAAe,AACf,6BAA8B,AAC9B,+BAAiC,CACpC,AACD,+CACI,aAAe,CAClB","file":"ChatMessage.vue","sourcesContent":["\n.align-center[data-v-347162d3] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n@-webkit-keyframes loadAudioPlayer-data-v-347162d3 {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@keyframes loadAudioPlayer-data-v-347162d3 {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@-webkit-keyframes loadAudioPlayerReset-data-v-347162d3 {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n@keyframes loadAudioPlayerReset-data-v-347162d3 {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n.animationLoadCircle[data-v-347162d3] {\n  -webkit-animation-name: loadAudioPlayer-data-v-347162d3;\n          animation-name: loadAudioPlayer-data-v-347162d3;\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards;\n}\n.animationLoadCircle.reset[data-v-347162d3] {\n    animation-direction: reverse;\n    -webkit-animation-duration: .5s;\n            animation-duration: .5s;\n}\n.chat-message[data-v-347162d3] {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin: 5px;\n  background-color: #009BFF;\n  padding: 6px 12px;\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n  border-radius: 15px 15px 15px 0;\n}\n.chat-message.self[data-v-347162d3] {\n    -ms-flex-item-align: end;\n        align-self: flex-end;\n    border-radius: 15px 15px 0 15px;\n}\n.chat-message.no-margin-top[data-v-347162d3] {\n    margin-top: 0;\n    border-radius: 0 15px 15px 0;\n}\n.chat-message.no-margin-top.self[data-v-347162d3] {\n    border-radius: 15px 0 0 15px;\n}\n.chat-message span[data-v-347162d3] {\n    color: #6200E5;\n}\n.chat-message pre[data-v-347162d3] {\n    font-family: 'Volte', sans-serif;\n    color: #ffffff;\n    white-space: pre-wrap;\n    word-break: break-all;\n}\n.chat-notification[data-v-347162d3] {\n  padding: 5px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.chat-notification.join[data-v-347162d3] {\n    color: #6200E5;\n}\n.chat-notification.leave[data-v-347162d3] {\n    color: #6F6F6F;\n}\n.chat-notification.attention[data-v-347162d3] {\n    color: #C2003C;\n    border-top: 2px solid #C2003C;\n    border-bottom: 2px solid #C2003C;\n}\n.chat-notification.disconnect[data-v-347162d3] {\n    color: #C2003C;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 935:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[(!_vm.message.notification)?_c('div',{staticClass:"chat-message",class:{
      self: _vm.message._id == _vm.myself,
      'no-margin-top': _vm.message.hide_name
    }},[_c('div',{staticClass:"container column"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.message._id != _vm.myself && !_vm.message.hide_name),expression:"message._id != myself && !message.hide_name"}]},[_vm._v(_vm._s(_vm.message.name))]),_vm._v(" "),(_vm.message.is_media)?_c('audio-player',{staticStyle:{"width":"250px"},attrs:{"src":_vm.message.media_url,"preDuration":_vm.message.media_duration}}):_c('pre',[_vm._v(_vm._s(_vm.message.message))])],1)]):_c('div',{staticClass:"chat-notification",class:[ _vm.message.notification_type ]},[_c('span',[_vm._v(_vm._s(_vm.message.message))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 936:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat",class:{ 'chat--padding': _vm.padding }},[_c('div',{staticClass:"chat__box"},[_c('div',{ref:"chat-messages",staticClass:"container column justify-end chat__box__messages"},_vm._l((_vm.messages),function(message,index){return _c('chat-message',{key:((message._id) + "-" + index),attrs:{"myself":_vm.person,"message":message}})}),1),_vm._v(" "),(!_vm.recording)?_c('form',{staticClass:"container chat__box__form",on:{"submit":function($event){$event.preventDefault();return _vm.send()}}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.messageText),expression:"messageText"}],ref:"message-area",staticClass:"input",attrs:{"name":"message","autofocus":""},domProps:{"value":(_vm.messageText)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleEnter.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.messageText=$event.target.value}}}),_vm._v(" "),(!_vm.canRecord)?_c('button',{staticClass:"btn btn-blue btn-rounded",attrs:{"type":"submit","name":"send"}},[_c('font-awesome-icon',{attrs:{"icon":"paper-plane"}})],1):_c('button',{staticClass:"btn btn-blue btn-rounded",attrs:{"type":"button","name":"record"},on:{"click":function($event){$event.preventDefault();return _vm.record()}}},[_c('font-awesome-icon',{attrs:{"icon":"microphone"}})],1)]):_c('div',{staticClass:"container chat__box__form"},[_c('button',{staticClass:"btn btn-red btn-rounded chat__box__form__cancel",attrs:{"type":"button","name":"cancel-record"},on:{"click":function($event){$event.preventDefault();return _vm.cancelRecord()}}},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1),_vm._v(" "),_c('span',{staticClass:"flex"},[_vm._v(_vm._s(_vm.recordTime))]),_vm._v(" "),_c('button',{staticClass:"btn btn-blue btn-rounded",attrs:{"type":"button","name":"send-record"},on:{"click":function($event){$event.preventDefault();return _vm.sendRecord()}}},[_c('font-awesome-icon',{attrs:{"icon":"paper-plane"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 937:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(805);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b61105_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(940);
function injectStyle (ssrContext) {
  __webpack_require__(938)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48b61105"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b61105_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(939);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("51c9b04e", content, true, {});

/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".align-center[data-v-48b61105]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@-webkit-keyframes loadAudioPlayer-data-v-48b61105{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@keyframes loadAudioPlayer-data-v-48b61105{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@-webkit-keyframes loadAudioPlayerReset-data-v-48b61105{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}@keyframes loadAudioPlayerReset-data-v-48b61105{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}.animationLoadCircle[data-v-48b61105]{-webkit-animation-name:loadAudioPlayer-data-v-48b61105;animation-name:loadAudioPlayer-data-v-48b61105;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.animationLoadCircle.reset[data-v-48b61105]{animation-direction:reverse;-webkit-animation-duration:.5s;animation-duration:.5s}.student-video-chat[data-v-48b61105]{position:relative;min-width:200px;max-width:calc(16.66667% - 60px);height:auto;padding:5px;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:5px}.student-video-chat__student[data-v-48b61105]{width:auto;height:auto;max-width:calc(100% - 10px);max-height:calc(100% - 10px)}.student-video-chat__student video[data-v-48b61105]{width:100%;height:auto}.student-video-chat__student__options[data-v-48b61105]{position:absolute;left:0;top:0;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-transition:display .2s;transition:display .2s;width:100%;height:auto;margin:5px;padding:5px}.student-video-chat__student__options__icon[data-v-48b61105]{float:right;margin-right:15px;width:25px;height:25px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:25px}.student-video-chat__student__options__icon.volume[data-v-48b61105]{background-color:#009bff}.student-video-chat__student__options__icon.attention[data-v-48b61105]{background-color:#c2003c}.student-video-chat__student--svg[data-v-48b61105]{width:63%!important;height:auto}.student-video-chat.hand-raised[data-v-48b61105]{border:2px solid #c2003c;padding:3px}.student-video-chat.hand-raised .student-video-chat__student__options[data-v-48b61105]{top:-2px;left:2px}.student-video-chat.talking[data-v-48b61105]{border:2px solid #009bff;padding:3px}.student-video-chat.talking .student-video-chat__student__options[data-v-48b61105]{top:-2px;left:2px}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/StudentVideoChat/index.vue"],"names":[],"mappings":"AACA,+BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,mDACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,2CACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,wDACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,gDACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,sCACE,uDAAwD,AAChD,+CAAgD,AACxD,qCAAsC,AAC9B,4BAA8B,CACvC,AACD,4CACI,4BAA6B,AAC7B,+BAAgC,AACxB,sBAAwB,CACnC,AACD,qCACE,kBAAmB,AACnB,gBAAiB,AACjB,iCAAyC,AACzC,YAAa,AACb,YAAa,AACb,eAAgB,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,UAAY,CACb,AACD,8CACI,WAAY,AACZ,YAAa,AACb,4BAA6B,AAC7B,4BAA8B,CACjC,AACD,oDACM,WAAY,AACZ,WAAa,CAClB,AACD,uDACM,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,+BAAgC,AAChC,uBAAwB,AACxB,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,WAAa,CAClB,AACD,6DACQ,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAoB,CAC3B,AACD,oEACU,wBAA0B,CACnC,AACD,uEACU,wBAA0B,CACnC,AACD,mDACI,oBAAsB,AACtB,WAAa,CAChB,AACD,iDACI,yBAA0B,AAC1B,WAAa,CAChB,AACD,uFACM,SAAU,AACV,QAAU,CACf,AACD,6CACI,yBAA0B,AAC1B,WAAa,CAChB,AACD,mFACM,SAAU,AACV,QAAU,CACf","file":"index.vue","sourcesContent":["\n.align-center[data-v-48b61105] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n@-webkit-keyframes loadAudioPlayer-data-v-48b61105 {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@keyframes loadAudioPlayer-data-v-48b61105 {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@-webkit-keyframes loadAudioPlayerReset-data-v-48b61105 {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n@keyframes loadAudioPlayerReset-data-v-48b61105 {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n.animationLoadCircle[data-v-48b61105] {\n  -webkit-animation-name: loadAudioPlayer-data-v-48b61105;\n          animation-name: loadAudioPlayer-data-v-48b61105;\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards;\n}\n.animationLoadCircle.reset[data-v-48b61105] {\n    animation-direction: reverse;\n    -webkit-animation-duration: .5s;\n            animation-duration: .5s;\n}\n.student-video-chat[data-v-48b61105] {\n  position: relative;\n  min-width: 200px;\n  max-width: calc((100% / 6) - (6 * 10px));\n  height: auto;\n  padding: 5px;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin: 5px;\n}\n.student-video-chat__student[data-v-48b61105] {\n    width: auto;\n    height: auto;\n    max-width: calc(100% - 10px);\n    max-height: calc(100% - 10px);\n}\n.student-video-chat__student video[data-v-48b61105] {\n      width: 100%;\n      height: auto;\n}\n.student-video-chat__student__options[data-v-48b61105] {\n      position: absolute;\n      left: 0;\n      top: 0;\n      -webkit-box-flex: 1;\n          -ms-flex: 1;\n              flex: 1;\n      -webkit-transition: display .2s;\n      transition: display .2s;\n      width: 100%;\n      height: auto;\n      margin: 5px;\n      padding: 5px;\n}\n.student-video-chat__student__options__icon[data-v-48b61105] {\n        float: right;\n        margin-right: 15px;\n        width: 25px;\n        height: 25px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        border-radius: 25px;\n}\n.student-video-chat__student__options__icon.volume[data-v-48b61105] {\n          background-color: #009BFF;\n}\n.student-video-chat__student__options__icon.attention[data-v-48b61105] {\n          background-color: #C2003C;\n}\n.student-video-chat__student--svg[data-v-48b61105] {\n    width: 63% !important;\n    height: auto;\n}\n.student-video-chat.hand-raised[data-v-48b61105] {\n    border: 2px solid #C2003C;\n    padding: 3px;\n}\n.student-video-chat.hand-raised .student-video-chat__student__options[data-v-48b61105] {\n      top: -2px;\n      left: 2px;\n}\n.student-video-chat.talking[data-v-48b61105] {\n    border: 2px solid #009BFF;\n    padding: 3px;\n}\n.student-video-chat.talking .student-video-chat__student__options[data-v-48b61105] {\n      top: -2px;\n      left: 2px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 940:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"student-video-chat",class:{ 'hand-raised': _vm.student.hand_raised, 'talking': !_vm.student.muted }},[(!_vm.student.active)?_c('font-awesome-icon',{staticClass:"modalstudent-video-chat__student student-video-chat__student--svg",attrs:{"icon":"sad-tear"}}):(!_vm.student.has_media)?_c('font-awesome-icon',{staticClass:"student-video-chat__student student-video-chat__student--svg",attrs:{"icon":"user"}}):_c('video',{ref:"video-player",staticClass:"student-video-chat__student",attrs:{"autoplay":""},domProps:{"muted":_vm.student.muted}}),_vm._v(" "),(_vm.canMute && _vm.student.active)?_c('div',{staticClass:"student-video-chat__student__options"},[(_vm.student.has_media)?_c('div',{staticClass:"student-video-chat__student__options__icon volume",on:{"click":function($event){return _vm.setMuted({ student_id: _vm.student._id, muted: !_vm.student.hand_raised ? !_vm.student.muted : false })}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.student.muted ? 'volume-mute' : 'volume-up'}})],1):_vm._e(),_vm._v(" "),(_vm.student.hand_raised)?_c('div',{staticClass:"student-video-chat__student__options__icon attention",on:{"click":function($event){return _vm.setMuted({ student_id: _vm.student._id, muted: !_vm.student.hand_raised ? !_vm.student.muted : false })}}},[_c('font-awesome-icon',{attrs:{"icon":"hand-paper"}})],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.student.name))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(981);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("29178a98", content, true, {});

/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".menu--relative[data-v-27f506d2]{position:relative;width:100%;min-height:100px;margin-bottom:20px;z-index:125}.menu--relative .menu--fixed[data-v-27f506d2]{background-image:-webkit-gradient(linear,left top,left bottom,color-stop(60%,#c50737),to(#cd1f26));background-image:linear-gradient(-180deg,#c50737 60%,#cd1f26);-webkit-box-shadow:0 0 55px 0 rgba(0,0,0,.5);box-shadow:0 0 55px 0 rgba(0,0,0,.5);position:fixed;top:0;left:0;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;z-index:100}.menu--relative .menu--fixed .menu--container[data-v-27f506d2]{color:#ff9aa6;min-height:100px;width:980px;max-width:90%;margin:0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.menu--relative .menu--fixed .menu--container a[data-v-27f506d2],.menu--relative .menu--fixed .menu--container router-link[data-v-27f506d2]{color:#ff9aa6;-webkit-transition:.1s;transition:.1s;font-size:14px}.menu--relative .menu--fixed .menu--container a[data-v-27f506d2]:hover,.menu--relative .menu--fixed .menu--container router-link[data-v-27f506d2]:hover{color:#fff}.menu--relative .menu--fixed .menu--container .menu--container__logo .logo[data-v-27f506d2]{max-width:100%;min-width:80px}.menu--relative .menu--fixed .menu--container .menu--container__links[data-v-27f506d2]{-webkit-transition:.3s;transition:.3s}.menu--relative .menu--fixed .menu--container .menu--container__links ul[data-v-27f506d2]{list-style:none;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.menu--relative .menu--fixed .menu--container .menu--container__links ul li a[data-v-27f506d2],.menu--relative .menu--fixed .menu--container .menu--container__links ul li router-link[data-v-27f506d2]{background:#fff;color:#c2003c;padding:10px 35px;border-radius:50px;margin:10px;line-height:35px;height:35px;font-size:14px;font-weight:900;-webkit-transition:.1s;transition:.1s}.menu--relative .menu--fixed .menu--container .menu--container__links ul li a[data-v-27f506d2]:hover,.menu--relative .menu--fixed .menu--container .menu--container__links ul li router-link[data-v-27f506d2]:hover{color:#fff;background:#fbc024}.menu--relative .menu--fixed .menu--container .menu--container__icons[data-v-27f506d2]{display:none}.menu--relative .menu--fixed .menu--container .menu--container__icons ul[data-v-27f506d2]{list-style:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.menu--relative .menu--fixed .menu--container .menu--container__icons ul li a[data-v-27f506d2],.menu--relative .menu--fixed .menu--container .menu--container__icons ul li router-link[data-v-27f506d2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;color:#c2003c;padding:10px;border-radius:50px;margin:5px;line-height:35px;height:35px;-webkit-transition:.1s;transition:.1s}.menu--relative .menu--fixed .menu--container .menu--container__icons ul li a[data-v-27f506d2]:hover,.menu--relative .menu--fixed .menu--container .menu--container__icons ul li router-link[data-v-27f506d2]:hover{color:#fff;background:#fbc024}.menu--relative .menu--fixed .menu--container .menu--container__icons ul li .fa[data-v-27f506d2]{font-size:16px}.example[data-v-27f506d2]{background:#00acc2;border-radius:4px;padding-top:0}@media screen and (max-width:1200px){.menu--container__links[data-v-27f506d2]{display:none}.menu--container__icons[data-v-27f506d2]{display:block!important}}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/header/teacher.vue"],"names":[],"mappings":"AACA,iCACE,kBAAmB,AACnB,WAAY,AACZ,iBAAkB,AAClB,mBAAoB,AACpB,WAAa,CACd,AACD,8CACI,mGAAyG,AACzG,8DAAiE,AACjE,6CAAkD,AAC1C,qCAA0C,AAClD,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,8BAA+B,AACvB,sBAAuB,AAC/B,WAAY,AACZ,WAAa,CAChB,AACD,+DACM,cAAe,AACf,iBAAkB,AAClB,YAAa,AACb,cAAe,AACf,cAAe,AACf,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACjC,AACD,4IAEQ,cAAe,AACf,uBAAyB,AACzB,eAAiB,AACjB,cAAgB,CACvB,AACD,wJAEU,UAAY,CACrB,AACD,4FACQ,eAAgB,AAChB,cAAgB,CACvB,AACD,uFACQ,uBAAyB,AACzB,cAAiB,CACxB,AACD,0FACU,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACrC,AACD,wMAEY,gBAAoB,AACpB,cAAe,AACf,kBAAmB,AACnB,mBAAoB,AACpB,YAAa,AACb,iBAAkB,AAClB,YAAa,AACb,eAAgB,AAChB,gBAAiB,AACjB,uBAAyB,AACzB,cAAiB,CAC5B,AACD,oNAEc,WAAY,AACZ,kBAAoB,CACjC,AACD,uFACQ,YAAc,CACrB,AACD,0FACU,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACrC,AACD,wMAEY,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAoB,AACpB,cAAe,AACf,aAAc,AACd,mBAAoB,AACpB,WAAY,AACZ,iBAAkB,AAClB,YAAa,AACb,uBAAyB,AACzB,cAAiB,CAC5B,AACD,oNAEc,WAAY,AACZ,kBAAoB,CACjC,AACD,iGACY,cAAgB,CAC3B,AACD,0BACE,mBAAoB,AACpB,kBAAmB,AACnB,aAAe,CAChB,AACD,qCACA,yCACI,YAAc,CACjB,AACD,yCACI,uBAA0B,CAC7B,CACA","file":"teacher.vue","sourcesContent":["\n.menu--relative[data-v-27f506d2] {\n  position: relative;\n  width: 100%;\n  min-height: 100px;\n  margin-bottom: 20px;\n  z-index: 125;\n}\n.menu--relative .menu--fixed[data-v-27f506d2] {\n    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(60%, #C50737), to(#CD1F26));\n    background-image: linear-gradient(-180deg, #C50737 60%, #CD1F26);\n    -webkit-box-shadow: 0 0 55px 0 rgba(0, 0, 0, 0.5);\n            box-shadow: 0 0 55px 0 rgba(0, 0, 0, 0.5);\n    position: fixed;\n    top: 0;\n    left: 0;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    width: 100%;\n    z-index: 100;\n}\n.menu--relative .menu--fixed .menu--container[data-v-27f506d2] {\n      color: #FF9AA6;\n      min-height: 100px;\n      width: 980px;\n      max-width: 90%;\n      margin: 0 auto;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.menu--relative .menu--fixed .menu--container a[data-v-27f506d2],\n      .menu--relative .menu--fixed .menu--container router-link[data-v-27f506d2] {\n        color: #FF9AA6;\n        -webkit-transition: 0.1s;\n        transition: 0.1s;\n        font-size: 14px;\n}\n.menu--relative .menu--fixed .menu--container a[data-v-27f506d2]:hover,\n        .menu--relative .menu--fixed .menu--container router-link[data-v-27f506d2]:hover {\n          color: #fff;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__logo .logo[data-v-27f506d2] {\n        max-width: 100%;\n        min-width: 80px;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__links[data-v-27f506d2] {\n        -webkit-transition: 0.3s;\n        transition: 0.3s;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__links ul[data-v-27f506d2] {\n          list-style: none;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__links ul li a[data-v-27f506d2],\n          .menu--relative .menu--fixed .menu--container .menu--container__links ul li router-link[data-v-27f506d2] {\n            background: #ffffff;\n            color: #C2003C;\n            padding: 10px 35px;\n            border-radius: 50px;\n            margin: 10px;\n            line-height: 35px;\n            height: 35px;\n            font-size: 14px;\n            font-weight: 900;\n            -webkit-transition: 0.1s;\n            transition: 0.1s;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__links ul li a[data-v-27f506d2]:hover,\n            .menu--relative .menu--fixed .menu--container .menu--container__links ul li router-link[data-v-27f506d2]:hover {\n              color: #fff;\n              background: #FBC024;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__icons[data-v-27f506d2] {\n        display: none;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__icons ul[data-v-27f506d2] {\n          list-style: none;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__icons ul li a[data-v-27f506d2],\n          .menu--relative .menu--fixed .menu--container .menu--container__icons ul li router-link[data-v-27f506d2] {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-pack: center;\n                -ms-flex-pack: center;\n                    justify-content: center;\n            -webkit-box-align: center;\n                -ms-flex-align: center;\n                    align-items: center;\n            background: #ffffff;\n            color: #C2003C;\n            padding: 10px;\n            border-radius: 50px;\n            margin: 5px;\n            line-height: 35px;\n            height: 35px;\n            -webkit-transition: 0.1s;\n            transition: 0.1s;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__icons ul li a[data-v-27f506d2]:hover,\n            .menu--relative .menu--fixed .menu--container .menu--container__icons ul li router-link[data-v-27f506d2]:hover {\n              color: #fff;\n              background: #FBC024;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__icons ul li .fa[data-v-27f506d2] {\n            font-size: 16px;\n}\n.example[data-v-27f506d2] {\n  background: #00ACC2;\n  border-radius: 4px;\n  padding-top: 0;\n}\n@media screen and (max-width: 1200px) {\n.menu--container__links[data-v-27f506d2] {\n    display: none;\n}\n.menu--container__icons[data-v-27f506d2] {\n    display: block !important;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 982:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"menu--relative"},[_c('div',{staticClass:"menu--fixed hidden"},[_c('div',{staticClass:"menu--container"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"menu--container__user"},[_c('userContent',{staticClass:"animation-right",attrs:{"data":_vm.teacher}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu--container__logo animation-left"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__(662),"width":"137","alt":"Minds"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu--container__links"},[_c('ul',{staticClass:"animation-top"},[_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu--container__icons"},[_c('ul',{staticClass:"animation-top"},[_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 999:
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var url = __webpack_require__(1000);
var parser = __webpack_require__(872);
var Manager = __webpack_require__(920);
var debug = __webpack_require__(775)('socket.io-client');

/**
 * Module exports.
 */

module.exports = exports = lookup;

/**
 * Managers cache.
 */

var cache = exports.managers = {};

/**
 * Looks up an existing `Manager` for multiplexing.
 * If the user summons:
 *
 *   `io('http://localhost/a');`
 *   `io('http://localhost/b');`
 *
 * We reuse the existing instance based on same scheme/port/host,
 * and we initialize sockets for each namespace.
 *
 * @api public
 */

function lookup (uri, opts) {
  if (typeof uri === 'object') {
    opts = uri;
    uri = undefined;
  }

  opts = opts || {};

  var parsed = url(uri);
  var source = parsed.source;
  var id = parsed.id;
  var path = parsed.path;
  var sameNamespace = cache[id] && path in cache[id].nsps;
  var newConnection = opts.forceNew || opts['force new connection'] ||
                      false === opts.multiplex || sameNamespace;

  var io;

  if (newConnection) {
    debug('ignoring socket cache for %s', source);
    io = Manager(source, opts);
  } else {
    if (!cache[id]) {
      debug('new io instance for %s', source);
      cache[id] = Manager(source, opts);
    }
    io = cache[id];
  }
  if (parsed.query && !opts.query) {
    opts.query = parsed.query;
  }
  return io.socket(parsed.path, opts);
}

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = parser.protocol;

/**
 * `connect`.
 *
 * @param {String} uri
 * @api public
 */

exports.connect = lookup;

/**
 * Expose constructors for standalone build.
 *
 * @api public
 */

exports.Manager = __webpack_require__(920);
exports.Socket = __webpack_require__(926);


/***/ })

});


// WEBPACK FOOTER //
// static/js/6.d8279d766c01bc2d77bb.js